import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);
/* Angular + external */
import {
  Component,
  OnInit,
  OnDestroy,
  OnChanges,
  AfterViewInit,
  QueryList,
  Renderer2,
  ChangeDetectionStrategy,
} from "@angular/core";
import { ViewChildren, ElementRef, ViewChild } from "@angular/core";
import { Input, Output, EventEmitter, SimpleChanges, ChangeDetectorRef } from "@angular/core";

import { Subscription } from "rxjs";
import { TabView } from "@bfx/primeng/tabview";
/***********************/
/* BFX */
// multi-asset
import * as CubiqTS from "shared/cubiq-model-multi-asset";
// cubiq-services
import {
  MarketDataEventTransformer,
  RateSubscriptionPromiseService,
  TraderGroupPromiseLookupService,
  MarkupCriteria,
  RateCache,
  CcyPairPromiseLookupService,
  RatePromiseService,
  CcyPairLookupService,
  TraderGroupLookupService,
  CurrencyPairCalendarPromiseLookupService,
  SystemConfigPromiseService,
  SysFeatures,
  BranchLookupService,
  ClientLookupService,
} from "shared/cubiq-services";

// global-services

import { TranslateService } from "@ngx-translate/core";
// order-entry services
import { OESettingsService } from "../services/basic/oe-settings.service";
import { OECoordinatorService } from "../services/oe-coordinator.service";
import { OEApiService } from "../services/oe-api.service";
import { OEUtilityService, PRIVATIZATION_LABEL } from "../services/basic/oe-utility.service";

// order-entry  models
import { OEPanelSpotModel } from "../data/models/oe-panel-spot.model";
import {
  OEInputLockStateItemModel,
  OELockingProfileTransportModel,
} from "../data/models/oe-locking-profile.model";
import { OECommandEventModel } from "../data/models/oe-command-event.model";
import { OEInputModel } from "../data/models/oe-input.model";
//  order-entry  enums
import { OENInputControl } from "../data/enums/oe-input-control.enum";
import { OENPanel } from "../data/enums/oe-panel.enum";
import { OENLockedState } from "../data/enums/oe-locked-state.enum";
import { OENCommand } from "../data/enums/oe-command.enum";
// interface controls components
import { ICAutocompleteComponent } from "./controls/ic-autocomplete.component";
import { BfxContactsInputComponent } from "./controls/bfx-contacts-input.component";

import { BfxClientIntentToggleComponent } from "./controls/bfx-toggle-client-intent.component";
import { BfxAmountSpinnerComponent } from "./controls/bfx-amount-spinner.component";
import { BfxPriceSpinnerComponent } from "./controls/bfx-price-spinner.component";
import { BfxValueDateComponent } from "../interface/controls/bfx-value-date.component";
import { BfxMarkupComponent } from "../interface/controls/bfx-markup.component";
import { BfxGoodFromUntilComponent } from "./controls/good-from-until/bfx-good-from-until.component";
import { BfxAutoCompleteComponent } from "app/bfx-element-library/bfx-autocomplete.component";
import { BfxSuspendControlComponent } from "../interface/controls/bfx-suspend-control.component";
// interface controls enums
import { ICNInputControlState } from "./controls/models/bfx-interface-controls.enums";
// interface controls models
import {
  ICFixedCcyModel,
  ICAutocompleteGenericModel,
  ICTenorValueDateModel,
  ICMarkupModel,
  ICSuspendModel,
} from "./controls/models/bfx-interface-controls.models";
import { ICExecutionModeComponent } from "./controls/ic-execution-mode.component";
import { ICAllowPartialFillsComponent } from "./controls/ic-allow-partial-fills.component";
import { ICHoldSTPComponent } from "./controls/ic-hold-stp.component";
import { ICPrivateOrderComponent } from "./controls/ic-private-order.component";
import { OEDLoadingDataModel } from "../data/models/oe-loading-data.model";
import { OENEntryType } from "../data/enums/oe-entry-type.enum";
import { OERateDataModel } from "../data/models/rate/oe-rate-data.model";
import { OERateTransportModel } from "../data/models/rate/oe-rate-transport.model";
import { OERateDisplayModel } from "../data/models/rate/oe-rate-display.model";
import { OELoggerService } from "../services/basic/oe-logger.service";
import { ICCcyPairStringComponent } from "./controls/ic-ccy-pair-string.component";
import { TRADING_SOURCE_INTERNAL } from "shared/cubiq-services/model/TradingSource.constants";
import { OENOperationMode } from "../data/enums/oe-operation-mode.enum";
import { ICGoodFromUntilModel } from "./controls/models/bfx-good-from-until.model";
import { OENLockingProfileType } from "../data/enums/oe-locking-profile-type.enum";
import { ICFixedCcyComponent } from "../../ic-controls/ic-fixed-ccy.component";
import { BfxConfigService } from "shared/auth-services/system-config/bfx-config.service";
import { InputText } from "@bfx/primeng/inputtext";
import { ICCustomFieldsComponent } from "src/app/order-entry/interface/controls/ic-custom-fields.component";
import { OEDatasetService } from "app/order-entry/services/basic/oe-dataset.service";
import { ICAllowStpAggComponent } from "./controls/ic-allow-stpagg.component";
import { BfxTrailingPipsSpinnerComponent } from "./controls/bfx-trailing-pips-spinner.component";
import { BfxTrailingTriggerSpinnerComponent } from "./controls/bfx-trailing-trigger-spinner.component";
import { Checkbox } from "@bfx/primeng/checkbox";
import { OEAdapterForwardService } from "../services/adapter/oe-adapter-forward.service";
import { OEModelGetterService } from "../services/model/oe-model-getter.service";
import { ConstraintValue } from "../../../shared/cubiq-services/model/core/ConstraintValue";

const BIG_NUMBER_ZERO: CubiqTS.BigNumber = new CubiqTS.BigNumber(0);

type MarkupData = {
  isMarkupRatesValid: boolean;
  isBuyBase: boolean;
  reverseEngineer: boolean;
  requestPrice: CubiqTS.BigNumber;
  markupDecs: CubiqTS.BigNumber;
};

@Component({
  selector: "oe-panel-spot-entry",
  templateUrl: "./html/oe-panel-spot-entry.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OESpotEntryComponent implements OnDestroy, OnInit, OnChanges, AfterViewInit {
  @Input() refId: string;
  @Input() rootRefId: string; // refId of the root order
  @Input() entryType: OENEntryType;
  @Input() operationMode: OENOperationMode;

  @Input() unTabbableTabs: boolean = true;
  /* Tab Index binding */
  tabIndex: number;

  @Output() tabIndexChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() dataLoadCompleted: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input()
  get tab() {
    return this.tabIndex;
  }

  set tab(value: any) {
    this.tabIndex = value;
    this.tabIndexChange.emit(this.tabIndex);
  }

  get hideMarkupTrackingRate(): boolean {
    return (
      this?.data?.markup?.value?.checkbox?.value === false ||
      CubiqTS.RequestOrderType.MARKET === this?.data?.orderType?.value?.value
    );
  }

  /**********************************************************************/
  /* DATA */
  public control: {
    showIntentAndAmount: boolean;
    /** Should  the Strategy currency row used in root call orders be shown */
    showRootCallCcy: boolean;
    multiplyAmountUserValue: number;
    multiplyAmountUserToggle: boolean;
    commentSize: number;
    lockAllFg: boolean;
    isLoading: boolean;
    initialLoadingComplete: boolean;
    lockingProfileData: Array<OEInputLockStateItemModel> | null;
    applyRateUpdatesToRequest: boolean;
    clientAccountConstraintAutoSelect: boolean;
    traderGroupAutocompleteConfig: {
      allowEmpty: boolean;
      forceSelection: boolean;
      customValidation: any;
    };
    triggerAutocompleteConfig: {
      // Used in NDF
      allowEmpty: boolean;
      forceSelection: boolean;
      customValidation: any;
    };
  } = {
    showIntentAndAmount: true,
    showRootCallCcy: false,
    multiplyAmountUserValue: 0,
    multiplyAmountUserToggle: false,
    commentSize: 250,
    lockAllFg: false,
    isLoading: true,
    initialLoadingComplete: false,
    lockingProfileData: null,
    applyRateUpdatesToRequest: true,
    clientAccountConstraintAutoSelect: true,
    traderGroupAutocompleteConfig: {
      allowEmpty: true,
      forceSelection: true,
      customValidation: null,
    },
    triggerAutocompleteConfig: {
      // Used in NDF
      allowEmpty: false,
      forceSelection: true,
      customValidation: null,
    },
  };

  public tabData: any = {
    financials: {
      label: "Financials",
      label_key: "order_entry.screen.tabs.label.financials",
    },
    more: {
      label: "More",
      label_key: "order_entry.screen.tabs.label.more",
    },
  };
  private fwdEnabled: boolean = false;
  private configMKTEnabled: boolean = false;

  public data: OEPanelSpotModel = new OEPanelSpotModel();

  public markupCheckboxEnabled: boolean = false;
  public latestRateData: any = null;
  public excludeMKT: boolean = true;
  public excludeTSL: boolean = true;

  // subscriptions
  private coordinatorSubscription: Subscription;
  private rateSubscription: Subscription;

  public oboEnabled: boolean = true;

  public hasCustomFields: boolean = true;

  /**********************************************************************/
  @ViewChild("tabs", { static: true }) elTabs: TabView;
  /* CLIENT -  Interface References */
  @ViewChildren("inputClient") icClient: QueryList<ICAutocompleteComponent>;
  @ViewChildren("inputAccount") icAccount: QueryList<ICAutocompleteComponent>;
  @ViewChildren("inputClientTrader") icClientTrader: QueryList<ICAutocompleteComponent>;
  @ViewChildren("inputContacts") contactsInputControl: QueryList<BfxContactsInputComponent>;

  /* FINANCIALS -  Interface References */
  @ViewChildren("inputCcyPair") icCcyPair: QueryList<ICCcyPairStringComponent>;
  @ViewChildren("inputOrderType") icOrderType: QueryList<ICAutocompleteComponent>;

  @ViewChildren("toggleClientIntent")
  clientIntentToggleControl: QueryList<BfxClientIntentToggleComponent>;
  /** Should be two fixed ccy components - one for normal strategy and one for top level call */
  @ViewChildren(ICFixedCcyComponent) fixedCcyControl: QueryList<ICFixedCcyComponent>;
  @ViewChildren("inputOrderAmount") orderAmountInputControl: QueryList<BfxAmountSpinnerComponent>;

  @ViewChildren("inputRequestPrice")
  requestPriceInputControl: QueryList<BfxPriceSpinnerComponent>;
  @ViewChildren("inputValueDate") valueDateInputControl: QueryList<BfxValueDateComponent>;
  @ViewChildren("inputMarkup") markupInputControl: QueryList<BfxMarkupComponent>;
  @ViewChildren("inputGoodFrom") goodFromInputControl: QueryList<BfxGoodFromUntilComponent>;
  @ViewChildren("inputGoodUntil") goodUntilInputControl: QueryList<BfxGoodFromUntilComponent>;
  @ViewChildren("inputTraderGroup") traderGroupInputControl: QueryList<BfxAutoCompleteComponent>;
  @ViewChildren("inputSuspend") suspendInputControl: QueryList<BfxSuspendControlComponent>;
  @ViewChildren("inputTrigger") triggerInputControl: QueryList<BfxAutoCompleteComponent>;
  @ViewChildren("inputTrailingPips")
  trailingPipsInputControl: QueryList<BfxTrailingPipsSpinnerComponent>;
  @ViewChildren("inputTrailingTrigger")
  trailingTriggerInputControl: QueryList<BfxTrailingTriggerSpinnerComponent>;
  @ViewChildren("trailingTriggerCheckbox")
  trailingTriggerCheckbox: QueryList<Checkbox>;

  /* MORE -  Interface References */
  @ViewChild("inputCommentClient") icCommentClient: ElementRef;
  @ViewChildren("inputExecutionMode") icExecutionMode: QueryList<ICExecutionModeComponent>;

  @ViewChildren("inputAllowPartialFills")
  icAllowPartialFills: QueryList<ICAllowPartialFillsComponent>;
  @ViewChildren("inputHoldSTP") icHoldSTP: QueryList<ICHoldSTPComponent>;
  @ViewChildren("inputPrivateOrder") icPrivateOrder: QueryList<ICPrivateOrderComponent>;
  @ViewChildren("inputAllowSTPAgg")
  icAllowSTPAgg: QueryList<ICAllowStpAggComponent>;

  @ViewChildren("oboClient") oboClient: QueryList<InputText>;
  @ViewChildren("oboAccount") oboAccount: QueryList<InputText>;
  @ViewChildren("customFieldComponent") customFields: QueryList<ICCustomFieldsComponent>;

  public RequestOrderType = CubiqTS.RequestOrderType;

  /**********************************************************************/
  /* CONSTRUCTOR  */
  constructor(
    protected translate: TranslateService,
    protected settings: OESettingsService,
    protected coordinator: OECoordinatorService,
    protected traderGroupService: TraderGroupPromiseLookupService,
    protected getter: OEModelGetterService,
    protected forwardAdapter: OEAdapterForwardService,
    protected utility: OEUtilityService,
    protected api: OEApiService,
    public cd: ChangeDetectorRef,
    //
    protected rateService: RatePromiseService,
    protected rateCache: RateCache,
    protected rateTransformer: MarketDataEventTransformer,
    protected rateSubscriptionService: RateSubscriptionPromiseService,
    protected currencyPairService: CcyPairPromiseLookupService,
    protected calendarService: CurrencyPairCalendarPromiseLookupService,
    protected oeLogger: OELoggerService,
    public renderer2: Renderer2,
    private sysConfigService: SystemConfigPromiseService,
    protected branchLookupService: BranchLookupService,
    protected configService: BfxConfigService,
    protected clientLookupService: ClientLookupService,
    datasetService: OEDatasetService,
  ) {
    this.sysConfigService.getSystemConfig(SysFeatures.fwdEnabled).then((value) => {
      this.fwdEnabled = "Y" == value || "y" == value ? true : false;
    });
    this.sysConfigService.getSystemConfig(SysFeatures.marketOrdersEnabled).then((value) => {
      this.configMKTEnabled = "Y" == value || "y" == value;
    });
    configService.getUIConfig().then((config) => {
      this.oboEnabled = config && config.general ? config.general.oboEnabled : false;
    });
    this.oeLogger = oeLogger.for(__dirname);

    this.hasCustomFields = datasetService?.customFieldDefns?.editable?.length > 0;
  }

  /**********************************************************************/
  /* LIFE CYCLE HOOKS */

  ngOnInit() {
    this.initialize();
  }

  ngOnDestroy() {
    this.unsubscribeRate(this.rootRefId, this.data.currencyPair.product);

    this.coordinatorSubscription.unsubscribe();
    if (this.rateSubscription) {
      this.rateSubscription.unsubscribe();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      switch (propName) {
        case "rootRefId":
          if (this.data.previousValue.rootRefId == null) {
            this.data.previousValue.rootRefId = this.rootRefId;
          } else if (
            typeof this.data.previousValue.rootRefId === "string" &&
            this.data.previousValue.rootRefId !== this.rootRefId
          ) {
            // If there is a root change (copy or edit), subscribe new rootRefId and unsubscribe old rootRefId
            setTimeout(() => {
              this.unsubscribeRate(
                this.data.previousValue.rootRefId,
                this.data.currencyPair.product,
              );
              this.subscribeRate(this.rootRefId, this.data.currencyPair.product);
              this.data.previousValue.rootRefId = this.rootRefId;
            }, 50);
          }
          break;
        case "entryType":
          // move along, nothing to see here!
          break;
      }
    }
  }

  ngAfterViewInit() {
    if (this.unTabbableTabs) {
      this.makeTabsUntabbable();
    }
    if (this.operationMode === OENOperationMode.NEW) {
      setTimeout(() => {
        this.propagateMarkupDefaultData();
      }, 200);
    }
  }

  /**********************************************************************/
  /* INITIALIZATION */

  protected initialize(): void {
    this.initializeSettings();
    this.initializeLabelTranslations();
    // create dataset
    this.orderTypeGetDataset(false);
    this.currencyPairsGetDataset();
    this.initializeTraderGroups();
    // subscriptions
    this.subscribeToCoordinator();
    //this.subscribeToRateEvents();
  }

  protected initializeSettings(): void {
    // client panel
    let clientSettings = this.settings.getSysConfigForClientPanel();
    this.data.clientTrader.enabled = clientSettings.clientTraderEnabled;
    this.data.contacts.size = clientSettings.contactsRenderSize;
    // financials panel
    let financialsSettings = this.settings.getSysConfigForFinancialsPanel();
    this.data.markup.config.markupCheckboxSelected = financialsSettings.markupLimitCbx;
    this.data.markup.config.markupEnabled = true; // financialsSettings.markupLimitEnabled;
    this.data.markup.config.markupEntry = financialsSettings.markupAllowLimitEntry;
    this.data.markup.config.markupType = financialsSettings.markupRetrievalTypeLimit;
    this.data.markup.config.markupLimitDefault = financialsSettings.markupLimitDefault;
    this.data.markup.config.markupRetrievalEnabled = financialsSettings.markupRetrievalEnabled;
    this.data.suspend.show = this.data.suspend.showConfig = financialsSettings.showSuspend;
    this.data.traderGroup.traderGroupModifiable = financialsSettings.traderGroupModifiable;
    // more panel
    let moreSettings = this.settings.getSysConfigForMorePanel();
    this.data.executionMode.show = this.data.executionMode.showConfig =
      moreSettings.showExecutionMode;
    this.data.privateOrder.show = this.data.privateOrder.showConfig = moreSettings.showPrivateOrder;
    this.data.commentPrivate.show = this.data.commentPrivate.showConfig =
      moreSettings.showCommentPrivate;
    this.data.holdSTP.enabledConfig = moreSettings.holdSTPisEnabled;
    this.data.commentClient.checkbox.show = moreSettings.showClientCommentCheckbox;
    this.data.stpAgg.enabledConfig = moreSettings.stpAggIsEnabled;
    // Profile settings
    this.control.multiplyAmountUserValue = this.settings.multiplyAmountUserValue;
    this.control.multiplyAmountUserToggle = this.settings.multiplyAmountUserToggle;
  }

  protected initializeLabelTranslations(): void {
    this.tabData.financials.label = this.translate.instant(this.tabData.financials.label_key);
    this.tabData.more.label = this.translate.instant(this.tabData.more.label_key);
    /********* FINANCIALS PANEL *********/
    this.data.orderType.label = this.translate.instant(this.data.orderType.labelKey);
    this.data.currencyPair.label = this.translate.instant(this.data.currencyPair.labelKey);
    this.data.requestPrice.label = this.translate.instant(this.data.requestPrice.labelKey);
    this.data.orderAmount.label = this.translate.instant(this.data.orderAmount.labelKey);
    this.data.clientIntent.label = this.translate.instant(this.data.clientIntent.labelKey);
    this.data.fixedCcy.strategyLabel = this.translate.instant(this.data.fixedCcy.strategyLabelKey);
    this.data.valueDate.label = this.translate.instant(this.data.valueDate.labelKey);
    this.data.markup.label = this.translate.instant(this.data.markup.labelKey);
    this.data.goodFrom.label = this.translate.instant(this.data.goodFrom.labelKey);
    this.data.goodUntil.label = this.translate.instant(this.data.goodUntil.labelKey);
    this.data.suspend.to.label = this.translate.instant(this.data.suspend.to.labelKey);
    this.data.suspend.from.label = this.translate.instant(this.data.suspend.from.labelKey);
    /********* MORE PANEL *********/
    this.data.commentPrivate.label = this.translate.instant(this.data.commentPrivate.labelKey);
    this.data.commentClient.label = this.translate.instant(this.data.commentClient.labelKey);
    this.data.holdSTP.label = this.translate.instant(this.data.holdSTP.labelKey);
    this.data.executionMode.label = this.translate.instant(this.data.executionMode.labelKey);
    this.data.privateOrder.label = this.translate.instant(this.data.privateOrder.labelKey);
    this.data.partialFill.label = this.translate.instant(this.data.partialFill.labelKey);
  }

  protected initializeTraderGroups(): void {
    this.traderGroupService.isPrimed().then(() => {
      this.loadTraderGroups();
    });
  }

  private propagateMarkupDefaultData(): void {
    if (this.data.markup.config.markupEntry) {
      // markupLimitCbx - if enabled sets markup to 0 Pips
      this.data.markup.value = new ICMarkupModel();

      let markup = this.data.markup.value;

      let checkSelected = markup.checkbox.enabled == true && markup.checkbox.value == true;

      if (this.data.markup.config.markupCheckboxSelected || checkSelected) {
        // Set default values
        markup.value = BIG_NUMBER_ZERO;
        markup.textValue = BIG_NUMBER_ZERO.toString();
        markup.typeValue = new ICAutocompleteGenericModel(CubiqTS.MarkUpType.Pips, "Pips");
        markup.checkbox.enabled = true;
        markup.checkbox.value = this.data.markup.config.markupCheckboxSelected;
      }

      this.updateMarkup(markup);
      this.displayMarkupRetrievalButton();
      this.data.markup.externalState = null;
      this.api.updateMarkup(this.refId, markup);
    }
  }

  /**********************************************************************/
  /* Tabs */

  public onTabActivate($event: any) {
    this.tab = $event.index;
  }

  private makeTabsUntabbable(): void {
    let financialsTab = this.elTabs.el.nativeElement.children[0].children[0].children[0];
    let moreTab = this.elTabs.el.nativeElement.children[0].children[0].children[1];
    this.renderer2.setAttribute(financialsTab, "tabIndex", "-1");
    this.renderer2.setAttribute(moreTab, "tabIndex", "-1");
  }

  /**********************************************************************/
  /* COORDINATOR HANDLER */
  private subscribeToCoordinator(): void {
    this.coordinatorSubscription = this.coordinator.entryPanelCmd$.subscribe(
      ($event: OECommandEventModel) => {
        if ($event.ref === this.refId) {
          this.cd.markForCheck();

          this.oeLogger.outputDevLogToConsole(
            ` SpotEntryPanel -> UPDATE: ${OENCommand[$event.cmd]} | Event: `,
            false,
            $event,
          );

          switch ($event.cmd) {
            case OENCommand.RESET_ALL:
              this.reset();
              break;
            case OENCommand.INVALID_INPUT:
              this.handleInvalidInput($event.data);
              break;
            case OENCommand.LOCK_ALL:
              this.lockAll();
              break;
            case OENCommand.UNLOCK_ALL:
              this.unlockAll();
              break;
            case OENCommand.LOAD_LOCKING_PROFILE:
              this.loadLockProfile($event.data);
              break;
            case OENCommand.LOAD_CONTROLS:
              this.load($event.data);
              if ($event.data instanceof OEDLoadingDataModel && !$event.data.singlePropagation) {
                this.informLoadComplete();
              }
              break;
            case OENCommand.UNBULK:
            case OENCommand.BULKED:
            case OENCommand.BULKING: {
              break;
            }
            default:
              logger.out.error(
                `ERROR: ${
                  this.constructor.name
                }.subscribeToCoordinator(): Command not implemented! command= (${$event.cmd}) [${
                  $event.cmd != null ? OENCommand[$event.cmd] : "NULL"
                }]`,
              );
              break;
          }
        }
      },
    );
  }

  private informLoadComplete(): void {
    setTimeout(() => {
      this.dataLoadCompleted.emit(true);
    }, 150);
  }

  /**********************************************************************/
  /* RESET */
  private reset(): void {
    this.resetData();
    this.resetLocking();
  }

  // handleResetAllControls
  protected resetData(): void {
    /********* CLIENT PANEL *********/
    this.icClient.forEach((c) => c.reset());
    this.icAccount.forEach((c) => c.reset());
    this.icClientTrader.forEach((c) => c.reset());
    this.contactsInputControl.forEach((c) => c.resetInputControl());
    /********* FINANCIALS PANEL *********/
    this.unsubscribeRate(this.rootRefId, this.data.previousValue.product);
    this.data.marketRate = new OERateDisplayModel();

    this.data.previousValue.client = null;
    this.data.previousValue.clientId = null;
    this.data.previousValue.inverted = false;
    this.data.previousValue.product = null;

    // Fixed ccy
    this.fixedCcyControl.forEach((c) => c.reset());
    this.data.fixedCcy.ccyPair = null;
    //
    this.data.currencyPair.inverted = false;
    this.control.showIntentAndAmount = true;
    this.control.showRootCallCcy = false;
    //
    this.data.markup.criteria = null;
    // Request Rate
    this.data.requestPrice.valueToBeLoaded = null;
    this.data.trailingPips.value = null;
    this.trailingPipsInputControl.forEach((c) => c.resetInputControl());
    this.trailingTriggerInputControl.forEach((c) => c.resetInputControl());
    this.data.trailingTrigger.value = null;
    //
    this.resetCurrencyPairData();
    this.icCcyPair.forEach((c) => c.reset());
    this.excludeMKT = true;
    this.excludeTSL = true;
    this.icOrderType.forEach((c) => c.reset());
    this.updateOrderTypeDatasetAvailability();
    this.clientIntentToggleControl.forEach((c) => c.resetInputControl());
    this.coordinator.cmdPropagateClientIntentChange(this.refId, CubiqTS.OrderIntent.BUY);

    this.orderAmountInputControl.forEach((c) => c.resetInputControl());

    // value date
    this.data.valueDate.dataset = null;
    this.valueDateInputControl.forEach((c) => c.resetInputControl());
    //
    this.requestPriceInputControl.forEach((c) => c.resetInputControl());
    // Markup
    this.markupInputControl.forEach((c) => c.resetInputControl());
    setTimeout(() => {
      this.propagateMarkupDefaultData();
    }, 100);
    // suspend
    this.data.suspend.value = null;
    this.data.suspend.from.externalState = null;
    this.data.suspend.to.externalState = null;

    this.suspendInputControl.forEach((c) => c.resetInputs());

    // reset good from
    this.data.goodFrom.value = null;
    this.data.goodFrom.externalState = null;
    this.data.goodFrom.errorMsg = null;
    this.data.goodFrom.constraintValidFg = true;
    this.goodFromInputControl.forEach((c) => c.resetInputControl());
    // reset good until
    this.data.goodUntil.value = null;
    this.data.goodUntil.externalState = null;
    this.data.goodUntil.errorMsg = null;
    this.data.goodUntil.constraintValidFg = true;
    this.goodUntilInputControl.forEach((c) => c.resetInputControl());
    // traderGroup reset
    this.data.traderGroup.value = null;
    //this.data.traderGroup.externalState = null;
    this.data.traderGroup.traderGroupVisited = false;
    this.data.traderGroup.state = ICNInputControlState.INACTIVE;
    // traderGroup dataset reset
    this.data.traderGroup.traderGroups = [];
    this.data.traderGroup.allTraderGroups = [];
    this.data.traderGroup.limitTraderGroups = [];
    this.data.traderGroup.manualTraderGroups = [];
    this.data.traderGroup.benchmarkTraderGroups = [];
    this.data.traderGroup.manualVoiceOnlyTraderGroups = [];
    this.initializeTraderGroups();
    /********* MORE PANEL *********/
    // reset private comment
    this.data.commentPrivate.value = null;
    this.data.commentPrivate.uiPrivatized = false;
    this.data.commentPrivate.externalState = null;
    // reset client comment
    this.data.commentClient.value = null;
    this.data.commentClient.uiPrivatized = false;
    this.data.commentClient.externalState = null;
    this.data.commentClient.checkbox.value = false;
    //  hold stp
    this.icHoldSTP.forEach((c) => c.reset());
    // execution mode
    this.data.executionMode.show = this.data.executionMode.showConfig;
    this.icExecutionMode.forEach((c) => c.reset());
    // Allow partial fills
    this.icAllowPartialFills.forEach((c) => c.reset());
    // reset private order
    this.data.privateOrder.show = this.data.privateOrder.showConfig;
    this.data.privateOrder.uiPrivatized = false;
    this.icPrivateOrder.forEach((c) => c.reset());
    // Allow STP Aggregation
    this.icAllowSTPAgg.forEach((c) => c.reset());

    // reset custom fields
    this.data.customValues.value = null;
    this.data.customValues.externalState = null;
    this.customFields.forEach((c) => c.resetInputControl());

    // OBOs
    this.data.oboClient.value = null;
    this.data.oboAccount.value = null;
  }

  protected resetLocking(): void {
    /********* CLIENT PANEL *********/
    this.data.client.lockState = OENLockedState.UNLOCKED;
    this.data.account.lockState = OENLockedState.UNLOCKED;
    this.data.contacts.lockState = OENLockedState.UNLOCKED;
    this.data.clientTrader.lockState = OENLockedState.UNLOCKED;
    /********* FINANCIALS PANEL *********/
    this.data.currencyPair.lockState = OENLockedState.UNLOCKED;
    this.data.orderType.lockState = OENLockedState.UNLOCKED;
    this.data.clientIntent.lockState = OENLockedState.UNLOCKED;
    this.data.fixedCcy.lockState = OENLockedState.UNLOCKED;
    this.data.orderAmount.lockState = OENLockedState.UNLOCKED;
    this.data.requestPrice.lockState = OENLockedState.UNLOCKED;
    this.data.trailingPips.lockState = OENLockedState.UNLOCKED;
    this.data.trailingTrigger.lockState = OENLockedState.UNLOCKED;
    this.data.valueDate.lockState = OENLockedState.UNLOCKED;
    this.data.goodFrom.lockState = OENLockedState.UNLOCKED;
    this.data.goodUntil.lockState = OENLockedState.UNLOCKED;
    this.data.markup.lockState = OENLockedState.UNLOCKED;
    this.data.trackingRate.lockState = OENLockedState.UNLOCKED;
    this.data.suspend.lockState = OENLockedState.UNLOCKED;
    this.data.traderGroup.lockState = OENLockedState.UNLOCKED;
    /********* MORE PANEL *********/
    this.data.commentPrivate.lockState = OENLockedState.UNLOCKED;
    this.data.commentClient.lockState = OENLockedState.UNLOCKED;
    this.data.customValues.lockState = OENLockedState.UNLOCKED;

    this.data.holdSTP.lockState = OENLockedState.UNLOCKED;
    this.data.executionMode.lockState = OENLockedState.UNLOCKED;
    this.data.privateOrder.lockState = OENLockedState.UNLOCKED;
    this.data.partialFill.lockState = OENLockedState.UNLOCKED;
    this.data.stpAgg.lockState = OENLockedState.UNLOCKED;
    /****************************/
    // OBO
    this.data.oboClient.lockState = OENLockedState.UNLOCKED;
    this.data.oboAccount.lockState = OENLockedState.UNLOCKED;

    this.unlockAll();
  }

  private resetMarkup(): void {
    let markup = (this.data.markup.value = new ICMarkupModel());
    markup.value = null;
    markup.textValue = "";
    markup.typeValue = null;
    markup.checkbox.enabled = true;
    markup.checkbox.value = false;
    this.updateMarkup(this.data.markup.value);
    this.api.updateMarkup(this.refId, this.data.markup.value);
    this.markupInputControl.forEach((c) => c.resetInputControl());
  }

  /**********************************************************************/
  /* EXTERNAL INPUT VALIDATION */

  protected handleInvalidInput(inputError: OEInputModel): void {
    if (
      inputError != null &&
      (inputError.panel === OENPanel.PANEL_CLIENT ||
        inputError.panel === OENPanel.PANEL_FINANCIALS ||
        inputError.panel === OENPanel.PANEL_MORE)
    ) {
      switch (inputError.input) {
        /********* CLIENT PANEL *********/
        case OENInputControl.CLIENT:
          // guard added to avoid marking client as invalid on duplicate based on external validation after model synthesis,
          // where the client is null due to visibility, related to OMS-35883
          if (
            this.control.initialLoadingComplete ||
            this.operationMode !== OENOperationMode.DUPLICATE
          ) {
            this.data.client.externalState = ICNInputControlState.INVALID;
          }
          break;
        case OENInputControl.ACCOUNT:
          if (
            this.control.initialLoadingComplete ||
            this.operationMode !== OENOperationMode.DUPLICATE
          ) {
            this.data.account.externalState = ICNInputControlState.INVALID;
          }
          break;
        case OENInputControl.TRADER:
          this.data.clientTrader.externalState = ICNInputControlState.INVALID;
          break;
        /********* FINANCIALS PANEL *********/
        case OENInputControl.CCY_PAIR:
          this.data.currencyPair.externalState = ICNInputControlState.INVALID;
          break;
        case OENInputControl.ORDER_TYPE:
          this.data.orderType.externalState = ICNInputControlState.INVALID;
          break;
        case OENInputControl.CLIENT_INTENT:
          //this.data.clientIntent.externalState = ICNInputControlState.INVALID;
          break;
        case OENInputControl.FIXED_CCY:
          //this.data.clientIntent.externalState = ICNInputControlState.INVALID;
          break;
        case OENInputControl.ORDER_AMOUNT:
          this.data.orderAmount.externalState = ICNInputControlState.INVALID;
          break;
        case OENInputControl.REQUEST_PRICE:
          this.data.requestPrice.externalState = ICNInputControlState.INVALID;
          break;
        case OENInputControl.VALUE_DATE:
          this.data.valueDate.externalState = ICNInputControlState.INVALID;
          break;
        case OENInputControl.TRIGGER:
          this.data.trigger.externalState = ICNInputControlState.INVALID;
          break;
        case OENInputControl.MARKUP:
          this.data.markup.externalState = ICNInputControlState.INVALID;
          break;
        case OENInputControl.GOOD_FROM:
          if (inputError.value != null && inputError.value !== "") {
            this.data.goodFrom.errorMsg = inputError.value;
          }
          this.data.goodFrom.externalState = ICNInputControlState.INVALID;

          break;
        case OENInputControl.GOOD_UNTIL:
          if (inputError.value != null && inputError.value !== "") {
            this.data.goodUntil.errorMsg = inputError.value;
            if (inputError.value === "timeout_parent_required") {
              this.data.goodUntil.externalStateOnLockAll = this.data.goodUntil.externalState;
            }
          }
          this.data.goodUntil.externalState = ICNInputControlState.INVALID;
          break;
        case OENInputControl.SUSPEND:
          // there is no longer a visually represented 'global invalid state' for suspend, it is on both fields
          this.data.suspend.externalState = ICNInputControlState.INVALID;
          this.data.suspend.from.externalState = ICNInputControlState.INVALID;
          this.data.suspend.to.externalState = ICNInputControlState.INVALID;
          break;
        case OENInputControl.SUSPEND_FROM:
          // this.data.suspend.externalState = ICNInputControlState.INVALID;
          this.data.suspend.from.externalState = ICNInputControlState.INVALID;
          break;
        case OENInputControl.SUSPEND_TO:
          // this.data.suspend.externalState = ICNInputControlState.INVALID;
          this.data.suspend.to.externalState = ICNInputControlState.INVALID;
          break;
        case OENInputControl.TRADER_GROUP:
          this.data.traderGroup.state = ICNInputControlState.INVALID;
          break;
        // ALGO locking
        case OENInputControl.ALGO_TYPE:
        case OENInputControl.LIMIT_PRICE:
          // do nothing
          break;
        /********* MORE PANEL *********/
        case OENInputControl.CLIENT_COMMENTS:
          this.data.commentClient.externalState = ICNInputControlState.INVALID;
          break;
        case OENInputControl.PRIVATE_COMMENTS:
          this.data.commentPrivate.externalState = ICNInputControlState.INVALID;
          break;
        case OENInputControl.HOLD_STP:
          //this.data.holdSTP.externalState = ICNInputControlState.INVALID;
          break;
        case OENInputControl.EXECUTION_MODE:
          // this.data.execution.externalState = ICNInputControlState.INVALID;
          break;
        case OENInputControl.PRIVATE_ORDER:
          // this.data.privateOrder.externalState = ICNInputControlState.INVALID;
          break;
        case OENInputControl.CUSTOM_FIELDS:
          this.data.customValues.externalState = ICNInputControlState.INVALID;

          break;
      }
    } else {
      logger.out.error(
        `ERROR: oe${
          OENEntryType[this.entryType]
        }Entry.handleInvalidInput(): NULL or Invalid panel: `,
        inputError,
      );
    }
    this.cd.markForCheck();
  }
  /**********************************************************************/
  /* LOAD */

  // handleLoadControls
  protected load(data: OEDLoadingDataModel): void {
    if (
      data != null &&
      data instanceof OEDLoadingDataModel &&
      data.values instanceof Array &&
      data.values.length > 0
    ) {
      this.control.isLoading = data.blockPropagation;
      this.control.clientAccountConstraintAutoSelect = false;

      let containsCheck: any = {
        type: false,
        goodFrom: false,
        goodUntil: false,
        executionMode: false,
      };

      for (let item of data.values) {
        /********* CLIENT PANEL *********/
        if (item.panel === OENPanel.PANEL_CLIENT) {
          switch (item.input) {
            case OENInputControl.CLIENT:
              if (item.hasPrivatization) {
                this.icClient.forEach((c) => c.setUIPrivatized(item.value));
              } else {
                this.data.client.value = item.value;
                if (OENOperationMode.MODIFY_INFO === this.operationMode) {
                  this.lockClientForModifyInfo();
                }
                this.icClient.forEach((c) => c.setDataValue(item.value, true, false, true));
                this.icClient.forEach((c) => c.autocompleteValidate());
                this.icClientTrader.forEach((c) => (c.input_constraint = item.value));

                this.propagateClientChange();
              }
              break;
            case OENInputControl.ACCOUNT:
              if (item.hasPrivatization) {
                this.icAccount.forEach((c) => c.setUIPrivatized(item.value));
              } else {
                this.data.account.value = item.value;
                if (OENOperationMode.MODIFY_INFO === this.operationMode) {
                  this.lockAccountForModifyInfo();
                }
                setTimeout(() => {
                  this.icAccount.forEach((c) => c.setDataValue(item.value, true, false, true));
                  this.icAccount.forEach((c) => c.autocompleteValidate());
                }, 0);
                setTimeout(() => {
                  this.icAccount.forEach((c) => c.checkAndLockAccountForClient());
                }, 300);

                this.propagateAccountChange();
              }
              break;
            case OENInputControl.CONTACT:
              this.data.contacts.value = item.value;
              break;
            case OENInputControl.TRADER:
              if (item.hasPrivatization) {
                this.icClientTrader.forEach((c) => c.setUIPrivatized(item.value));
              } else {
                this.data.clientTrader.value = item.value;
                this.icClientTrader.forEach((c) => c.setDataValue(item.value, true, false, true));
                //this.icClientTrader.autocompleteValidate();
              }
              break;
            default:
              break;
          }
          /********* FINANCIALS PANEL *********/
        } else if (item.panel === OENPanel.PANEL_FINANCIALS) {
          this.loadFinancials(item, containsCheck, data);

          /********* MORE PANEL *********/
        } else if (item.panel === OENPanel.PANEL_MORE) {
          switch (item.input) {
            case OENInputControl.CLIENT_COMMENTS:
              if (typeof item.value === "string" && item.value === PRIVATIZATION_LABEL) {
                this.data.commentClient.value = item.value;
                this.data.commentClient.privatizationLabel = item.value;
                this.data.commentClient.uiPrivatized = true;
                this.data.commentClient.lockState = OENLockedState.LOCKED;
                this.data.commentClient.locked = true;
              } else if (item.value == null || typeof item.value === "string") {
                this.data.commentClient.value = item.value;
              } else {
                logger.out.error(
                  `ERROR: oe${
                    OENEntryType[this.entryType]
                  }Entry.handleLoadControls(): Invalid client comment value!`,
                );
              }
              break;
            case OENInputControl.PRIVATE_COMMENTS:
              if (typeof item.value === "string" && item.value === PRIVATIZATION_LABEL) {
                this.data.commentPrivate.value = item.value;
                this.data.commentPrivate.privatizationLabel = item.value;
                this.data.commentPrivate.uiPrivatized = true;
                this.data.commentPrivate.lockState = OENLockedState.LOCKED;
                this.data.commentPrivate.locked = true;
              } else if (item.value == null || typeof item.value === "string") {
                this.data.commentPrivate.value = item.value;
                this.onCommentPrivateChange();
              } else {
                logger.out.error(
                  `ERROR: oe${
                    OENEntryType[this.entryType]
                  }Entry.handleLoadControls(): Invalid private comment value!`,
                );
              }
              break;
            case OENInputControl.CUSTOM_FIELDS:
              this.customFields.forEach((c) =>
                c.loadCustomValues(item.value.customValues, item.value.hasStrategyFill),
              );
              break;
            case OENInputControl.HOLD_STP:
              this.icHoldSTP.forEach((c) => c.load(item.value));
              break;
            case OENInputControl.PRIVATE_ORDER:
              if (typeof item.value === "string" && item.value === PRIVATIZATION_LABEL) {
                this.icPrivateOrder.forEach((c) => c.load(true));
                this.data.privateOrder.uiPrivatized = true;
              } else {
                this.icPrivateOrder.forEach((c) => c.load(item.value));
              }
              break;
            case OENInputControl.EXECUTION_MODE: // CubiqTS.ExecutionType
              containsCheck.executionMode = true;
              this.data.executionMode.value = item.value;
              this.icExecutionMode.forEach((c) => c.load(item.value));
              break;
            case OENInputControl.PARTIAL_FILL: {
              if (this.icAllowPartialFills.length === 1) {
                const ic = this.icAllowPartialFills.first;
                ic.load(item.value);
                this.data.partialFill.value = ic.data.value;
                this.evaluateSTPAgg();
              } else if (ConstraintValue.is(item.value?.value)) {
                this.data.partialFill.value = item.value?.value;
              } else {
                this.data.partialFill.value = ConstraintValue.None;
              }
              break;
            }
            case OENInputControl.STP_AGG: {
              const value = item.value ?? ConstraintValue.None;
              this.icAllowSTPAgg.forEach((c) => c.load(item.value));
              this.data.stpAgg.value = value;
              this.evaluateSTPAgg();
              break;
            }
          }
        } else if (item.panel === OENPanel.PANEL_OBO) {
          switch (item.input) {
            case OENInputControl.OBO_CLIENT:
              this.data.oboClient.value = item.value;
              break;
            case OENInputControl.OBO_ACCOUNT:
              this.data.oboAccount.value = item.value;
              break;
          }
        } else {
          logger.out.error(
            `ERROR: oe${
              OENEntryType[this.entryType]
            }Entry.handleLoadControls(): Invalid panel for item: `,
            item,
          );
        }
      }

      if (!data.singlePropagation) {
        this.postLoad(containsCheck);
      }

      // set account auto-select on constraint (added because of OMS-35837)
      setTimeout(() => {
        this.control.clientAccountConstraintAutoSelect = true;
      }, 100);
      // setting flag that indicates that data has been loaded at least once
      setTimeout(() => {
        this.control.initialLoadingComplete = true;
      }, 500);
    } else {
      setTimeout(() => {
        this.control.isLoading = false;
      });

      logger.out.warn(
        `ERROR: oe${OENEntryType[this.entryType]}Entry.handleLoadControls(): Data is NULL: `,
        data,
      );
    }
  }

  protected loadFinancials(item: any, containsCheck: any, data: OEDLoadingDataModel): void {
    switch (item.input) {
      case OENInputControl.CCY_PAIR:
        this.icCcyPair.forEach((c) => c.load(item.value));
        //this.setCurrencyPair(item.value);
        let comparisonProduct = this.data.previousValue.inverted
          ? this.data.previousValue.product.substr(3, 3) +
            this.data.previousValue.product.substr(0, 3)
          : this.data.previousValue.product;
        if (
          this.refId === this.rootRefId ||
          this.api.getModifyIssuerRefId(this.refId) === this.refId
        ) {
          // guard valid only for the root, issue OMS-26559; and if this is the starting leg for modify.
          let requestLoadItem = data.values.find((loadItem: OEInputModel) => {
            return loadItem.input === OENInputControl.REQUEST_PRICE;
          });
          this.data.requestPrice.valueToBeLoaded =
            requestLoadItem != null &&
            requestLoadItem.value != null &&
            item.value !== comparisonProduct
              ? true
              : null; // (this.data.requestPrice.value == null || requestLoadItem.value.textValue !== this.data.requestPrice.value.textValue)
        } else {
          this.data.requestPrice.valueToBeLoaded = null;
        }

        this.onCcyPairBlur(item.value);
        break;
      case OENInputControl.ORDER_TYPE:
        if (item.value == null) {
          this.icOrderType.forEach((c) => c.reset());
        } else {
          containsCheck.type = true;
          if (item.value != null && item.value.value == CubiqTS.RequestOrderType.CALL) {
            this.control.showIntentAndAmount = false;
            this.control.showRootCallCcy =
              this.getter.isRootNode(this.refId) && !this.getter.isRootNodeAlone(this.refId);
            this.coordinator.cmdPropagateClientIntentChange(this.refId, null);
          } else {
            this.control.showIntentAndAmount = true;
            this.control.showRootCallCcy = false;

            this.coordinator.cmdPropagateClientIntentChange(
              this.refId,
              this.data.clientIntent.value,
            );
          }

          this.updateOrderTypeDatasetAvailability();
          this.orderTypeGetDataset(); // needed for TSL on Loops
          // must be before setDataValue
          // NB : this prevent the initial setDataValue - when you load the form - from triggering propagation
          // is is already done at the end of setDataValue
          // this.data.previousValue.orderType.lastValidId =
          //   item.value instanceof ICAutocompleteGenericModel
          //     ? item.value.value
          //     : this.data.previousValue.orderType.lastValidId;
          // this.data.previousValue.orderType.lastId =
          //   item.value instanceof ICAutocompleteGenericModel ? item.value.value : null;
          // load value - will trigger order type propagation
          this.icOrderType.forEach((c) => c.setDataValue(item.value, true, true, true));
          //this.icOrderType.forEach(c => c.autocompleteValidate());
          // line below must be invoked after the order-type is set OMS-35934
          this.updateRateApplicationToRequestRateGuard();
        }
        break;
      case OENInputControl.CLIENT_INTENT:
        this.clientIntentToggleControl.forEach((c) => c.writeValue(item.value));
        break;
      case OENInputControl.FIXED_CCY:
        if (item.value instanceof ICFixedCcyModel || item.value === null) {
          this.fixedCcyControl.forEach((c) => c.load(item.value, true));
          this.data.fixedCcy.ccyPair = item.value.ccyPair;
          //this.data.fixedCcy.currency = item.value.ccy;
        }
        break;
      case OENInputControl.ORDER_AMOUNT:
        if (this.data.orderAmount.value !== item.value) {
          this.data.orderAmount.value = item.value;
          this.orderAmountInputControl.forEach((c) => c.loadValue(item.value));
        }
        break;
      case OENInputControl.REQUEST_PRICE:
        if (item.value == null) {
          this.data.requestPrice.value = null;
          this.requestPriceInputControl.forEach((c) => c.resetInputControl());
        } else {
          this.data.requestPrice.value = item.value;
          this.requestPriceInputControl.forEach((c) => c.writeValue(item.value));
          this.requestPriceInputControl.forEach((c) => c.validateValue());
        }
        break;
      case OENInputControl.TRAILING_PIPS: {
        if (item.value == null) {
          this.data.trailingPips.value = null;
          this.trailingPipsInputControl.forEach((c) => c.resetInputControl());
        } else {
          this.data.trailingPips.value = item.value;
          this.trailingPipsInputControl.forEach((c) => c.loadValue(item.value));
        }
        break;
      }
      case OENInputControl.TRAILING_TRIGGER: {
        if (item.value == null) {
          this.data.trailingTrigger.checkbox.value = false;
        } else {
          this.data.trailingTrigger.value = item.value;
          this.data.trailingTrigger.checkbox.value = true;
          this.trailingTriggerInputControl.forEach((c) => c.writeValue(item.value));
          this.trailingTriggerInputControl.forEach((c) => c.updateValidState());
        }
        break;
      }
      case OENInputControl.VALUE_DATE:
        if (item.value instanceof ICTenorValueDateModel) {
          this.data.valueDate.value = item.value;
          this.data.valueDate.isSpot =
            this.data.valueDate.value && this.data.valueDate.value.tenor == CubiqTS.Tenor.SPOT;
          this.data.valueDate.isBrokenDate =
            this.data.valueDate.value &&
            this.data.valueDate.value.tenor == null &&
            this.data.valueDate.value.valueDate != null;
          this.valueDateInputControl.forEach((c) => c.writeValue(item.value));
        }
        break;
      case OENInputControl.MARKUP:
        if (item.value instanceof ICMarkupModel) {
          this.data.markup.value = item.value;
          this.markupInputControl.forEach((c) => c.load(item.value));
          // fix for OMS-33516
          if (item.value.checkbox.enabled && item.value.checkbox.value) {
            this.displayMarkupRetrievalButton();
          }
        }
        break;
      case OENInputControl.GOOD_FROM:
        containsCheck.goodFrom = true;
        this.goodFromInputControl.forEach((c) => c.loadGoodFromUntil(item.value));
        break;
      case OENInputControl.GOOD_UNTIL:
        containsCheck.goodUntil = true;
        this.goodUntilInputControl.forEach((c) => c.loadGoodFromUntil(item.value, false));
        break;
      case OENInputControl.SUSPEND:
        this.suspendInputControl.forEach((c) => c.loadSuspendValue(item.value));
        break;
      case OENInputControl.SUSPEND_FROM:
      case OENInputControl.SUSPEND_TO:
        logger.out.error("Individual suspend from/to load not implemented! Load value = ", item);
        break;
      case OENInputControl.TRADER_GROUP:
        // CubiqTS.TradingGroupImpl
        if (this.operationMode == OENOperationMode.MODIFY) {
          // If no OCR flag or OCR is false then we enable trader group
          this.data.traderGroup.traderGroupModifiable = !(
            item.value?.orderCancelReplaceFg ?? false
          );
        }
        if (!this.utility.compareObjects(this.data.traderGroup.value, item.value)) {
          this.data.traderGroup.value = item.value === "" ? null : item.value;
          this.data.traderGroup.traderGroupVisited = true;
          this.onTraderGroupChange();
          this.validateTraderGroup();
        }
        break;
      case OENInputControl.TRIGGER:
        this.data.trigger.value = item.value;
        // using this.load* pattern of validate + notify api
        // as internal validation routines may
        // update 'api' 's view of trigger to null before this load completes -dc
        this.validateTrigger();
        this.onTriggerChange();
        break;
      default:
        // no-op for debugging
        break;
    }
  }

  private lockAccountForModifyInfo() {
    this.data.account.lockState = OENLockedState.LOCKED;
    this.icAccount.forEach((c) => c.lock());
  }

  private lockClientForModifyInfo() {
    this.data.client.lockState = OENLockedState.LOCKED;
    this.icClient.forEach((c) => c.lock());
  }

  protected postLoad(containsCheck: any): void {
    /********* CLIENT PANEL *********/
    this.contactsInputControl.forEach((contactControl) => {
      contactControl.writeClient(this.data.client.value);
      contactControl.writeClientTrader(this.data.clientTrader.value);
      contactControl.writeValue(this.data.contacts.value);
      contactControl.loadComplete();
    });

    /********* FINANCIALS PANEL *********/
    if (!containsCheck.type) this.orderTypeGetDataset(); // needed for TSL on Loops
    /********* MORE PANEL *********/
    if (!containsCheck.executionMode) this.updateTraderGroups();

    this.cd.markForCheck();
    setTimeout(() => {
      this.control.isLoading = false;
      this.updateOrderTypeDatasetAvailability();
    }, 0);
    setTimeout(() => {
      this.propagateOrderTypeChange(true);
      // suspend fix when loading root from strategy leg
      if (this.api.doesStrategyHaveMKTLeg(this.refId)) {
        this.api.updateActionsAndNotificationsPanelsForMKTOrder(this.refId);
        if (
          this.data.suspend.value instanceof ICSuspendModel &&
          this.data.suspend.value.activated
        ) {
          this.api.clearSuspendOnMKTStrategyLegs(this.refId);
        }

        if (this.data.suspend.lockState === OENLockedState.UNLOCKED) {
          this.data.suspend.lockState = OENLockedState.LOCKED;
          this.updateLocking();
        }
      }

      this.updateRetrieveMarkupEnabled();
    }, 150);
  }

  /**********************************************************************/
  /* LOCKING */

  private lockAll(): void {
    this.control.lockAllFg = true;
    this.updateLocking();
  }

  private unlockAll(): void {
    this.control.lockAllFg = false;
    this.updateLocking();
  }

  protected loadLockProfile(lockingProfile: OELockingProfileTransportModel): void {
    if (lockingProfile instanceof OELockingProfileTransportModel) {
      for (let lockStateItem of lockingProfile.profile) {
        if (
          lockStateItem.panel === OENPanel.PANEL_CLIENT ||
          lockStateItem.panel === OENPanel.PANEL_FINANCIALS ||
          lockStateItem.panel === OENPanel.PANEL_MORE ||
          lockStateItem.panel === OENPanel.PANEL_OBO
        ) {
          this.assignLockStateToData(lockStateItem);
        }
      }
      if (lockingProfile.profileType === OENLockingProfileType.PERSISTENT) {
        this.control.lockingProfileData = lockingProfile.profile;
      }
      this.updateLocking();
    } else {
      logger.out.error(`Invalid locking profile`);
    }
  }

  protected assignLockStateToData(lockStateItem: OEInputLockStateItemModel): void {
    switch (lockStateItem.input) {
      /********* CLIENT PANEL *********/
      case OENInputControl.CLIENT:
        this.data.client.lockState = lockStateItem.lockState;
        break;
      case OENInputControl.ACCOUNT:
        this.data.account.lockState = lockStateItem.lockState;
        break;
      case OENInputControl.CONTACT:
        this.data.contacts.lockState = lockStateItem.lockState;
        break;
      case OENInputControl.TRADER:
        this.data.clientTrader.lockState = lockStateItem.lockState;
        break;
      /********* FINANCIALS PANEL *********/
      case OENInputControl.ACCOUNT_ACTIVE_TAB:
      case OENInputControl.CLIENT_ACTIVE_TAB:
        // Do nothing, not in use for locking
        break;
      case OENInputControl.CCY_PAIR:
        this.data.currencyPair.lockState = lockStateItem.lockState;
        break;
      case OENInputControl.ORDER_TYPE:
        this.data.orderType.lockState = lockStateItem.lockState;
        break;
      case OENInputControl.CLIENT_INTENT:
        this.data.clientIntent.lockState = lockStateItem.lockState;
        break;
      case OENInputControl.FIXED_CCY:
        this.data.fixedCcy.lockState = lockStateItem.lockState;
        break;
      case OENInputControl.ORDER_AMOUNT:
        this.data.orderAmount.lockState = lockStateItem.lockState;
        break;
      case OENInputControl.REQUEST_PRICE:
        this.data.requestPrice.lockState = lockStateItem.lockState;
        break;
      case OENInputControl.TRAILING_PIPS:
        this.data.trailingPips.lockState = lockStateItem.lockState;
        break;
      case OENInputControl.TRAILING_TRIGGER:
        this.data.trailingTrigger.lockState = lockStateItem.lockState;
        break;
      case OENInputControl.VALUE_DATE:
        this.data.valueDate.lockState = lockStateItem.lockState;
        break;
      case OENInputControl.TRIGGER:
        this.data.trigger.lockState = lockStateItem.lockState;
        break;
      case OENInputControl.MARKUP:
        this.data.markup.lockState = lockStateItem.lockState;
        this.data.trackingRate.lockState = lockStateItem.lockState;
        break;
      case OENInputControl.GOOD_FROM:
        this.data.goodFrom.lockState = lockStateItem.lockState;
        break;
      case OENInputControl.GOOD_UNTIL:
        this.data.goodUntil.lockState = lockStateItem.lockState;
        break;
      case OENInputControl.SUSPEND:
        this.data.suspend.lockState = lockStateItem.lockState;
        break;
      case OENInputControl.SUSPEND_FROM:
      case OENInputControl.SUSPEND_TO:
        // Do nothing, not in use for locking
        break;
      case OENInputControl.TRADER_GROUP:
        this.data.traderGroup.lockState = lockStateItem.lockState;
        break;
      // ALGO controls
      case OENInputControl.ALGO_TYPE:
      case OENInputControl.LIMIT_PRICE:
        // don nothing
        break;
      /********* MORE PANEL *********/
      case OENInputControl.CLIENT_COMMENTS:
        this.data.commentClient.lockState = lockStateItem.lockState;
        break;
      case OENInputControl.PRIVATE_COMMENTS:
        this.data.commentPrivate.lockState = lockStateItem.lockState;
        break;
      case OENInputControl.CUSTOM_FIELDS:
        this.data.customValues.lockState = lockStateItem.lockState;
        break;
      case OENInputControl.EXECUTION_MODE:
        this.data.executionMode.lockState = lockStateItem.lockState;
        break;
      case OENInputControl.PRIVATE_ORDER:
        this.data.privateOrder.lockState = lockStateItem.lockState;
        break;
      case OENInputControl.HOLD_STP:
        this.data.holdSTP.lockState = lockStateItem.lockState;
        break;
      case OENInputControl.PARTIAL_FILL:
        this.data.partialFill.lockState = lockStateItem.lockState;
        break;
      case OENInputControl.STP_AGG:
        this.data.stpAgg.lockState = lockStateItem.lockState;
        break;
      case OENInputControl.MARKUP_TYPE: // integrated with markup
      case OENInputControl.FIXING_SOURCE: // not used in spot entry
      case OENInputControl.FIXING_DATE: // not used in spot entry
        break;
      case OENInputControl.OBO_CLIENT:
        this.data.oboClient.lockState = lockStateItem.lockState;
        break;
      case OENInputControl.OBO_ACCOUNT:
        this.data.oboAccount.lockState = lockStateItem.lockState;
        break;
      default:
        this.oeLogger.outputExtendedLogging(
          `Warn: oe${
            OENEntryType[this.entryType]
          }Entry.handleLoadLockProfile(): unidentified lock item: %O`,
          lockStateItem,
        );
        break;
    }
  }

  protected updateLocking(): void {
    if (!this.control.lockAllFg) {
      // lockAll is INACTIVE
      //client
      if (this.data.client.lockState === OENLockedState.LOCKED) {
        this.icClient.forEach((c) => c.lock());
      } else if (this.data.client.lockState === OENLockedState.UNLOCKED) {
        this.icClient.forEach((c) => c.unlock());
      }
      // account
      if (this.data.account.lockState === OENLockedState.LOCKED) {
        this.icAccount.forEach((c) => c.lock());
      } else if (this.data.account.lockState === OENLockedState.UNLOCKED) {
        this.icAccount.forEach((c) => c.unlock());
      }
      // contact
      if (this.data.contacts.lockState === OENLockedState.LOCKED) {
        this.contactsInputControl.forEach((c) => c.lockInputControl());
      } else if (this.data.contacts.lockState === OENLockedState.UNLOCKED) {
        this.contactsInputControl.forEach((c) => c.unlockInputControl());
      }
      // client trader
      if (this.data.clientTrader.lockState === OENLockedState.LOCKED) {
        this.icClientTrader.forEach((c) => c.lock());
      } else if (this.data.clientTrader.lockState === OENLockedState.UNLOCKED) {
        this.icClientTrader.forEach((c) => c.unlock());
      }
      // CCY_PAIR:
      if (this.data.currencyPair.lockState === OENLockedState.LOCKED) {
        this.icCcyPair.forEach((c) => c.lock());
      } else if (this.data.currencyPair.lockState === OENLockedState.UNLOCKED) {
        this.icCcyPair.forEach((c) => c.unlock());
      }
      // ORDER_TYPE:
      if (this.data.orderType.lockState === OENLockedState.LOCKED) {
        this.icOrderType.forEach((c) => c.lock());
      } else if (this.data.orderType.lockState === OENLockedState.UNLOCKED) {
        this.icOrderType.forEach((c) => c.unlock());
      }
      // CLIENT_INTENT:
      if (this.data.clientIntent.lockState === OENLockedState.LOCKED) {
        this.clientIntentToggleControl.forEach((c) => c.lockInputControl());
      } else if (this.data.clientIntent.lockState === OENLockedState.UNLOCKED) {
        this.clientIntentToggleControl.forEach((c) => c.unlockInputControl());
      }
      // FIXED_CCY:
      if (this.data.fixedCcy.lockState === OENLockedState.LOCKED) {
        this.fixedCcyControl.forEach((c) => c.lock());
      } else if (this.data.fixedCcy.lockState === OENLockedState.UNLOCKED) {
        this.fixedCcyControl.forEach((c) => c.unlock());
      }
      // ORDER_AMOUNT:
      if (this.data.orderAmount.lockState === OENLockedState.LOCKED) {
        this.orderAmountInputControl.forEach((c) => c.lockInputControl());
      } else if (this.data.orderAmount.lockState === OENLockedState.UNLOCKED) {
        this.orderAmountInputControl.forEach((c) => c.unlockInputControl());
      }
      //REQUEST_PRICE:
      if (this.data.requestPrice.lockState === OENLockedState.LOCKED) {
        this.requestPriceInputControl.forEach((c) => c.lockInputControl());
      } else if (this.data.requestPrice.lockState === OENLockedState.UNLOCKED) {
        this.requestPriceInputControl.forEach((c) => c.unlockInputControl());
      }
      //TRAILING_PIPS:
      if (this.data.trailingPips.lockState === OENLockedState.LOCKED) {
        this.trailingPipsInputControl.forEach((c) => c.lockInputControl());
      } else if (this.data.trailingPips.lockState === OENLockedState.UNLOCKED) {
        this.trailingPipsInputControl.forEach((c) => c.unlockInputControl());
      }
      //TRAILING_TRIGGER:
      if (this.data.trailingTrigger.lockState === OENLockedState.LOCKED) {
        this.trailingTriggerInputControl.forEach((c) => c.lockInputControl());
        this.trailingTriggerCheckbox.forEach((c) => c.setDisabledState(true));
      } else if (this.data.trailingTrigger.lockState === OENLockedState.UNLOCKED) {
        this.trailingTriggerInputControl.forEach((c) => c.unlockInputControl());
        this.trailingTriggerCheckbox.forEach((c) => c.setDisabledState(false));
      }
      // VALUE_DATE:
      if (this.data.valueDate.lockState === OENLockedState.LOCKED) {
        this.valueDateInputControl.forEach((c) => c.lockInputControl());
      } else if (this.fwdEnabled && this.data.valueDate.lockState === OENLockedState.UNLOCKED) {
        this.valueDateInputControl.forEach((c) => c.unlockInputControl());
      }
      // MARKUP:
      if (this.data.markup.lockState === OENLockedState.LOCKED) {
        this.markupInputControl.forEach((c) => c.lockInputControl());
        this.data.trackingRate.locked = true;
      } else if (this.data.markup.lockState === OENLockedState.UNLOCKED) {
        this.markupInputControl.forEach((c) => c.unlockInputControl());
        this.data.trackingRate.locked = false;
      }
      // TRIGGER:
      if (this.data.trigger.lockState === OENLockedState.LOCKED) {
        this.data.trigger.locked = true;
      } else if (this.data.trigger.lockState === OENLockedState.UNLOCKED) {
        this.data.trigger.locked = false;
      }
      // GOOD FROM:
      if (this.data.goodFrom.lockState === OENLockedState.LOCKED) {
        // this.data.goodFrom.locked = true;
        this.goodFromInputControl.forEach((c) => c.lockInputControl());
      } else if (this.data.goodFrom.lockState === OENLockedState.UNLOCKED) {
        // this.data.goodFrom.locked = false;
        this.goodFromInputControl.forEach((c) => c.unlockInputControl());
      }
      // GOOD UNTIL:
      if (this.data.goodUntil.lockState === OENLockedState.LOCKED) {
        // this.data.goodUntil.locked = true;
        this.goodUntilInputControl.forEach((c) => c.lockInputControl());
      } else if (this.data.goodUntil.lockState === OENLockedState.UNLOCKED) {
        // this.data.goodUntil.locked = false;
        this.goodUntilInputControl.forEach((c) => c.unlockInputControl());
      }
      // SUSPEND :
      if (this.data.suspend.lockState === OENLockedState.LOCKED) {
        this.suspendInputControl.forEach((c) => c.lockInputControl());
      } else if (this.data.suspend.lockState === OENLockedState.UNLOCKED) {
        this.suspendInputControl.forEach((c) => c.unlockInputControl());
      }
      // TRADER GROUP
      if (this.data.traderGroup.lockState === OENLockedState.LOCKED) {
        this.data.traderGroup.locked = true;
      } else if (this.data.traderGroup.lockState === OENLockedState.UNLOCKED) {
        this.data.traderGroup.locked = false;
      }
      // PRIVATE COMMENTS
      if (this.data.commentPrivate.uiPrivatized) {
        // privatization locked (lock state is lower priority)
        this.data.commentPrivate.locked = true;
      } else if (this.data.commentPrivate.lockState === OENLockedState.LOCKED) {
        this.data.commentPrivate.locked = true;
      } else if (this.data.commentPrivate.lockState === OENLockedState.UNLOCKED) {
        if (this.rootRefId != this.refId && !this.settings.independentComments) {
          this.data.commentPrivate.locked = true;
        } else {
          this.data.commentPrivate.locked = false;
        }
      } else {
        this.data.commentPrivate.locked = false;
        logger.out.error(`Invalid MoreDetails->Private Comment lock state!`); // remove after dev testing
      }
      // CLIENT COMMENTS:
      if (this.data.commentClient.uiPrivatized) {
        // privatization locked (lock state is lower priority)
        this.data.commentClient.locked = true;
      } else if (this.data.commentClient.lockState === OENLockedState.LOCKED) {
        this.data.commentClient.locked = true;
      } else if (this.data.commentClient.lockState === OENLockedState.UNLOCKED) {
        if (this.rootRefId != this.refId && !this.settings.independentComments) {
          this.data.commentClient.locked = true;
        } else {
          this.data.commentClient.locked = false;
        }
      } else {
        this.data.commentClient.locked = false;
        logger.out.error(`Invalid MoreDetails->Client Comment lock state!`);
      }
      // Custom Fields
      if (this.data.customValues.lockState === OENLockedState.LOCKED) {
        this.customFields.forEach((c) => c.lockInputControl());
      } else if (this.data.customValues.lockState === OENLockedState.UNLOCKED) {
        this.customFields.forEach((c) => c.unlockInputControl());
      }
      // HOLD STP
      if (this.data.holdSTP.lockState === OENLockedState.LOCKED) {
        this.icHoldSTP.forEach((c) => c.lock());
      } else if (this.data.holdSTP.lockState === OENLockedState.UNLOCKED) {
        this.icHoldSTP.forEach((c) => c.unlock());
      }
      // PRIVATE ORDER
      if (this.data.privateOrder.uiPrivatized) {
        // privatization locked
        this.icPrivateOrder.forEach((c) => c.lock());
      } else if (this.data.privateOrder.lockState === OENLockedState.LOCKED) {
        this.icPrivateOrder.forEach((c) => c.lock());
      } else if (this.data.privateOrder.lockState === OENLockedState.UNLOCKED) {
        this.icPrivateOrder.forEach((c) => c.unlock());
      }
      // EXECUTION MODE
      if (this.data.executionMode.lockState === OENLockedState.LOCKED) {
        this.icExecutionMode.forEach((c) => c.lock());
      } else if (this.data.executionMode.lockState === OENLockedState.UNLOCKED) {
        this.icExecutionMode.forEach((c) => c.unlock());
      }
      // PARTIAL_FILL:
      if (this.data.partialFill.lockState === OENLockedState.LOCKED) {
        this.icAllowPartialFills.forEach((c) => c.lock());
      } else if (this.data.partialFill.lockState === OENLockedState.UNLOCKED) {
        this.icAllowPartialFills.forEach((c) => c.unlock());
      }
      if (this.data.stpAgg.lockState === OENLockedState.LOCKED) {
        this.icAllowSTPAgg.forEach((c) => c.lock());
      } else if (this.data.stpAgg.lockState === OENLockedState.UNLOCKED) {
        this.icAllowSTPAgg.forEach((c) => c.unlock());
      }
      // OBO
      this.data.oboClient.disabled = this.data.oboClient.lockState === OENLockedState.LOCKED;
      this.data.oboAccount.disabled = this.data.oboAccount.lockState === OENLockedState.LOCKED;
    } else {
      // lockAll is ACTIVE
      // CLIENT
      this.icClient.forEach((c) => c.lock());
      this.icAccount.forEach((c) => c.lock());
      this.icClientTrader.forEach((c) => c.lock());
      this.contactsInputControl.forEach((c) => c.lockInputControl());
      // FINANCIALS
      this.icCcyPair.forEach((c) => c.lock());
      this.icOrderType.forEach((c) => c.lock());
      this.clientIntentToggleControl.forEach((c) => c.lockInputControl());
      this.fixedCcyControl.forEach((c) => c.lock());
      this.orderAmountInputControl.forEach((c) => c.lockInputControl());
      this.requestPriceInputControl.forEach((c) => c.lockInputControl());
      this.trailingPipsInputControl.forEach((c) => c.lockInputControl());
      this.trailingTriggerInputControl.forEach((c) => c.lockInputControl());
      this.trailingTriggerCheckbox.forEach((c) => c.setDisabledState(true));
      this.valueDateInputControl.forEach((c) => c.lockInputControl());
      this.markupInputControl.forEach((c) => c.lockInputControl());
      this.goodFromInputControl.forEach((c) => c.lockInputControl());
      this.goodUntilInputControl.forEach((c) => c.lockInputControl());
      this.suspendInputControl.forEach((c) => {
        c.lockInputControl();
      });
      this.data.traderGroup.locked = true;
      this.data.trackingRate.locked = true;
      this.data.trigger.locked = true;
      // MORE
      this.data.commentPrivate.locked = true;
      this.data.commentClient.locked = true;
      this.data.customValues.locked = true;
      this.icHoldSTP.forEach((c) => c.lock());
      this.icPrivateOrder.forEach((c) => c.lock());
      this.icExecutionMode.forEach((c) => c.lock());
      this.icAllowPartialFills.forEach((c) => c.lock());
      this.icAllowSTPAgg.forEach((c) => c.lock());
      this.customFields.forEach((c) => c.lockInputControl());
      // OBO
      this.data.oboClient.disabled = true;
      this.data.oboAccount.disabled = true;
    }
    this.updateExternalStateOnUpdateLocking();
    this.cd.markForCheck();
  }

  /**
   * e.g. clear transient errors related to adding strategy
   */
  private updateExternalStateOnUpdateLocking() {
    if (this.control.lockAllFg) {
      this.data.goodUntil.externalState = this.data.goodUntil.externalStateOnLockAll;
      this.data.goodUntil.errorMsg =
        this.data.goodUntil.externalState === ICNInputControlState.INVALID
          ? this.data.goodUntil.errorMsg
          : null;
    }
  }

  /**********************************************************************/
  /* DATASET  */
  private orderTypeGetDataset(applyToInterface: boolean = true): void {
    let result: Array<ICAutocompleteGenericModel<any>> = this.api.loadOrderTypeDatasetForOrder(
      this.refId,
      this.excludeMKT,
      this.excludeTSL,
    );
    if (result != null && result instanceof Array) {
      this.data.orderType.dataset = result; //.slice();
      if (applyToInterface) {
        this.icOrderType.forEach((c) => c.initializeOnChanges());
      }
    } else {
      logger.out.error(
        `ERROR: oe${
          OENEntryType[this.entryType]
        }Entry.orderTypeGetDataset(): Order types dataset load failed!`,
      );
      this.data.orderType.dataset = [];
    }
  }

  private displayMarkupRetrievalButton(): void {
    this.updateRetrieveMarkupEnabled();

    if (
      this.data.markup.config.markupRetrievalEnabled &&
      this.data.markup.config.markupType !== "MANUAL"
    ) {
      this.markupInputControl.forEach((c) => c.displayMarkupRefresh(true));
    }
  }

  /**
   * Load all currency pairs from the replicate provided base lookup service
   * and fill in the appropriate currency pair values (inverted too, where applicable)
   * in the data model
   */
  protected currencyPairsGetDataset(): void {
    // SPT/FWD CcyPair Dataset
    let dataset = this.api.getSpotFwdPairsDataset();
    if (dataset != null && dataset instanceof Array && dataset.length > 0) {
      this.data.ccyPairDatasets.sptFwdDataset = dataset.slice();
      this.data.currencyPair.dataset = dataset.slice();
    } else {
      logger.out.error(
        `ERROR: oe${
          OENEntryType[this.entryType]
        }Entry.currencyPairsGetDataset(): CcyPairs dataset load failed!`,
      );
      this.data.ccyPairDatasets.sptFwdDataset = [];
      this.data.currencyPair.dataset = [];
    }
    // MKT CcyPair Dataset
    let datasetMKT = this.api.getSpotFwdMKTCcyPairsDataset();
    if (datasetMKT != null && datasetMKT instanceof Array && datasetMKT.length > 0) {
      this.data.ccyPairDatasets.mktDataset = datasetMKT.slice();
    } else {
      logger.out.warn(
        `WARNING: oe${
          OENEntryType[this.entryType]
        }Entry.currencyPairsGetDataset(): CcyPairs MKT dataset load failed!`,
      );
      this.data.ccyPairDatasets.mktDataset = [];
    }
  }

  /**********************************************************************/
  /* CONTACTS MANAGER - CLIENT  */

  public onClientDefaultCommentsChanged($event: any): void {
    // updating client default comments overrides previously set independent comments
    if ($event.hasClientTraderComment) {
      this.api.updateClientTraderDefaultComment(this.refId, $event.clientTraderComment);
      this.api.updateClientDefaultComments(this.refId, $event.clientComment, $event.privateComment);
    } else {
      this.api.updateClientDefaultComments(
        this.refId,
        this.data.client.value.defaultClientComment,
        this.data.client.value.defaultPrivateComment,
      );
      this.propagateClientDefaultCommentsChange($event);
    }
  }

  public onClientTraderUpdate($event: any): void {
    this.data.clientTrader.value = $event;

    this.cd.markForCheck();

    if (this.icClientTrader != null) {
      // OMS-23843
      this.icClientTrader.forEach((c) =>
        c.setDataValue(this.data.clientTrader.value, true, false, true),
      );
      this.icClientTrader.forEach((c) => c.autocompleteValidate());
    }

    this.data.clientTrader.externalState = null;
    this.api.updateClientTrader(this.refId, this.data.clientTrader.value);
  }

  public onContactManagerOpen($event: any): void {
    this.api.cmdFreezeInterfaceControls(this.refId);
  }

  public onContactManagerClosed($event: any): void {
    this.api.cmdUnfreezeInterfaceControls(this.refId);
  }

  /**********************************************************************/
  /* CONTROL SETTERS - CLIENT  */

  public onClientChange($event: any): void {
    const isChanged =
      $event instanceof CubiqTS.ClientImpl && this.data.client.value?.clientId === $event?.clientId;

    this.cd.detectChanges();

    this.oeLogger.outputDevLogToConsole(
      `PANEL Client UPDATE VALUE: ${
        this.data.client.value instanceof CubiqTS.ClientImpl ? this.data.client.value.clientId : " "
      } | Object= `,
      false,
      this.data.client.value,
    );
    this.data.client.externalState = null;
    this.api.updateClient(this.refId, this.data.client.value);
    this.updateRetrieveMarkupEnabled();
    this.updateOrderTypeDatasetAvailability();

    // we want this out here as propagate* are called when switching between orders in a strategy
    if (isChanged) this.clearSTPAgg();
  }

  public onClientSelect($event: any): void {
    let clientId = $event;
    this.oeLogger.outputDevLogToConsole("PANEL Client PREDICTED VALUE: ", false, $event);
    this.evaluateMarkupByBranch(clientId);
  }

  public onAccountChange($event: any): void {
    this.data.account.externalState = null;
    this.api.updateAccount(this.refId, this.data.account.value);
    this.updateRetrieveMarkupEnabled();
  }

  public onContactsChange($event: any): void {
    this.data.contacts.externalState = null;
    this.data.contacts.value = $event;
    this.api.updateContacts(this.refId, this.data.contacts.value);
    // propagate
    this.propagateClientChange();
  }

  public onClientTraderChange($event: any): void {
    this.data.clientTrader.externalState = null;
    this.api.updateClientTrader(this.refId, this.data.clientTrader.value);
  }

  /**********************************************************************/
  /* CONTROL SETTERS - FINANCIALS  */

  public onCcyPairBlur($event: any): void {
    let ccyPairIsNew: boolean = this.setCurrencyPair($event);
    if (ccyPairIsNew) {
      let propagateOnAllNodes: boolean = this.api.isRoot(this.refId);
      let omitMKTNodes: boolean =
        propagateOnAllNodes &&
        this.data.currencyPair.model instanceof CubiqTS.CurrencyPairImpl &&
        this.data.currencyPair.model.allowMarketOrdersFg;

      this.oeLogger.outputDevLogToConsole(
        ` Invoking api.updateCcyPair(${this.refId}, ${this.data.currencyPair.product}, model, ${propagateOnAllNodes}, ${propagateOnAllNodes})`,
      );
      this.data.currencyPair.externalState = null;
      this.api.updateCcyPair(
        this.refId,
        this.data.currencyPair.product,
        this.data.currencyPair.model,
        propagateOnAllNodes,
        omitMKTNodes,
      );
      this.updateRetrieveMarkupEnabled();
      this.updateOrderTypeDatasetAvailability();
    }
  }

  public onOrderTypeChange($event: any, fromControl: boolean = false): void {
    // check if orderType has changed
    if (
      (this.data.orderType.value == null && this.data.previousValue.orderType.lastId != null) ||
      (this.data.orderType.value != null &&
        this.data.orderType.value.value !== this.data.previousValue.orderType.lastId)
    ) {
      let orderTypeValue = this.data.orderType.value;
      if (orderTypeValue != null && orderTypeValue.label == "CALL") {
        this.resetMarkup();
      } else {
        if (fromControl && (!$event || $event["label"] == "CALL")) {
          if (orderTypeValue != null && this.checkMarkupDefault(orderTypeValue.value)) {
            this.updateMarkup(this.data.markup.config.markupLimitDefault);
          }
        }
      }
      this.data.orderType.externalState = null;
      this.api.updateOrderType(this.refId, this.data.orderType.value);
      this.propagateOrderTypeChange();

      // we want this out here as propagate* are called when switching between orders in a strategy
      this.evaluateSTPAgg();

      // Update tracking
      this.updateMarkupRates();
      this.updateRetrieveMarkupEnabled();
      // update previous values
      this.data.previousValue.orderType.lastId =
        this.data.orderType.value != null ? this.data.orderType.value.value : null;
      this.data.previousValue.orderType.lastValidId =
        this.data.orderType.value != null
          ? this.data.orderType.value.value
          : this.data.previousValue.orderType.lastValidId;
    }
  }

  public onClientIntentToggleChange($event: any): void {
    this.data.clientIntent.externalState = null;
    this.api.updateClientIntent(this.refId, this.data.clientIntent.value);
    // Update tracking
    this.updateMarkupRates();
    this.updateRetrieveMarkupEnabled();
  }

  public onFixedCcyToggleChange($event: any): void {
    if (
      this.data.fixedCcy.value != null &&
      typeof this.data.fixedCcy.value.ccy === "string" &&
      this.data.fixedCcy.value.ccy.length === 3
    ) {
      this.data.fixedCcy.fixedCcy = this.data.fixedCcy.value.ccy;
    } else {
      this.data.fixedCcy.fixedCcy = null;
    }

    let propagateOnAllNodes: boolean = this.api.isRoot(this.refId);
    let omitMKTNodes: boolean =
      propagateOnAllNodes &&
      this.data.currencyPair.model instanceof CubiqTS.CurrencyPairImpl &&
      this.data.currencyPair.model.allowMarketOrdersFg;

    this.api.updateFixedCcy(
      this.refId,
      this.data.fixedCcy.value,
      propagateOnAllNodes,
      omitMKTNodes,
    );
    // Update tracking
    this.updateMarkupRates();
    this.updateRetrieveMarkupEnabled();
  }

  public onOrderAmountChange($event: any): void {
    this.data.orderAmount.externalState = null;
    this.api.updateOrderAmount(this.refId, this.data.orderAmount.value);
  }

  public onOrderAmountBlur($event: any): void {
    let orderAmountUserValue = new CubiqTS.BigNumber(this.control.multiplyAmountUserValue);
    if (
      this.data.orderAmount.value != null &&
      this.data.orderAmount.value.isLessThan(orderAmountUserValue) &&
      this.control.multiplyAmountUserToggle === true
    ) {
      this.data.orderAmount.value = this.data.orderAmount.value.times(1000000);
    }
    this.data.orderAmount.externalState = null;
    this.api.updateOrderAmount(this.refId, this.data.orderAmount.value);
    //
    this.updateRetrieveMarkupEnabled();
  }

  public onRequestPriceChange($event: any): void {
    this.data.requestPrice.externalState = null;
    this.api.updateRequestPrice(this.refId, this.data.requestPrice.value);
    // Update tracking if markup checkbox is active
    if (this.markupCheckboxEnabled) {
      this.updateRetrieveMarkupEnabled();
    }
    this.updateMarkupRates();
  }

  public onTrailingPipsChange(_: CubiqTS.BigNumber | null): void {
    this.data.trailingPips.externalState = null;
    this.api.updateTrailingPips(this.refId, this.data.trailingPips.value);
  }

  public onTrailingTriggerChange(_: CubiqTS.BigNumber | null): void {
    this.data.trailingTrigger.externalState = null;
    this.api.updateTrailingTrigger(this.refId, this.data.trailingTrigger.value);
  }

  public onValueDateChange($event: any): void {
    let wasSpot = this.data.valueDate.isSpot;
    this.data.valueDate.isSpot =
      this.data.valueDate.value && this.data.valueDate.value.tenor == CubiqTS.Tenor.SPOT
        ? true
        : false;
    this.data.valueDate.isBrokenDate =
      this.data.valueDate.value &&
      this.data.valueDate.value.tenor == null &&
      this.data.valueDate.value.valueDate != null
        ? true
        : false;
    this.data.valueDate.externalState = null;
    this.api.updateValueDate(this.refId, this.data.valueDate.value);

    if (this.data.valueDate.isSpot !== wasSpot) {
      this.updateMarkupRates();
    }
  }

  public onMarkupChange($event: any): void {
    this.data.markup.externalState = null;
    if (
      this.data.markup.value instanceof ICMarkupModel &&
      this.data.markup.value !== null &&
      this.data.markup.config.markupEnabled &&
      this.data.markup.config.markupEntry
    ) {
      this.api.updateMarkup(this.refId, this.data.markup.value);
      this.updateMarkupRates();
    }
  }

  public onMarkupCheckboxState(state: boolean): void {
    this.markupCheckboxEnabled = state;
    if (state) {
      if (this.data.markup.config.markupEntry) {
        // markupLimitCbx - if enabled sets markup to 0 Pips
        if (!this.data.markup.value) {
          this.data.markup.value = new ICMarkupModel();
          this.data.markup.value.checkbox.value = state;
          this.data.markup.value.checkbox.enabled = this.data.markup.config.markupEntry;
        }
        let markup = this.data.markup.value;
        let checkSelected = markup.checkbox.enabled == true && markup.checkbox.value == true;
        if (this.data.markup.config.markupCheckboxSelected || checkSelected) {
          // Set default values
          markup.value = BIG_NUMBER_ZERO;
          markup.textValue = BIG_NUMBER_ZERO.toString();
          markup.typeValue = new ICAutocompleteGenericModel(CubiqTS.MarkUpType.Pips, "Pips");
          markup.checkbox.enabled = true;
          markup.checkbox.value = true;
        }

        this.updateMarkup(markup);
        this.displayMarkupRetrievalButton();
        this.data.markup.externalState = null;
        this.api.updateMarkup(this.refId, markup);
      }
      this.updateMarkupRates();
    } else {
      this.resetMarkup();
    }
  }

  public onSuspendChange($event: any): void {
    this.data.suspend.externalState = null;
    this.api.updateSuspend(this.refId, this.data.suspend.value);
  }

  public onGoodFromChange(): void {
    this.data.goodFrom.errorMsg = null;
    this.data.goodFrom.externalState = null;
    this.api.updateGoodFrom(this.refId, this.data.goodFrom.value);

    if (this.data.goodUntil?.value != null) {
      this.goodUntilInputControl?.first?.validate();
    }

    this.cd.markForCheck();
  }

  public onGoodUntilChange(): void {
    this.data.goodUntil.errorMsg = null;
    this.data.goodUntil.externalState = null;
    this.api.updateGoodUntil(this.refId, this.data.goodUntil.value);

    if (this.data.goodFrom?.value != null) {
      this.goodFromInputControl?.first?.validate();
    }

    this.cd.markForCheck();
  }

  public onTraderGroupChange(): void {
    this.api.updateTraderGroup(this.refId, this.data.traderGroup.value);
  }

  public onTriggerChange(): void {
    if (this.data.trigger.externalState != null) {
      this.data.trigger.externalState = null;
      this.cd.markForCheck();
    }
    this.api.updateTrigger(this.refId, this.data.trigger.value);
  }

  public onTrailingTriggerCheckboxChange(): void {
    this.onTrailingTriggerChange(this.data.trailingTrigger.value);
    if (this.data.trailingTrigger.checkbox.value == false) {
      this.updateTrailingTrigger();
    }
    this.api.updateTrailingTriggerProvided(this.refId, this.data.trailingTrigger.checkbox.value);
  }

  private updateTrailingTrigger() {
    if (this.isTSL() && this.data.trailingPips.value instanceof CubiqTS.BigNumber) {
      // recalculate implied trailingTrigger from current trailingPips
      // (occurs in BfxTrailingTriggerSpinnerComponent.doTrailingTriggerCalc)
      this.data.trailingPips.value = new CubiqTS.BigNumber(this.data.trailingPips.value);
      this.cd.markForCheck();
    }
  }

  /**********************************************************************/
  /* CONTROL -> MODEL SETTERS - MORE PANEL */

  public onCommentPrivateChange(): void {
    if (!this.data.commentPrivate.uiPrivatized) {
      this.data.commentPrivate.externalState = null;
      this.api.updatePrivateComment(this.refId, this.data.commentPrivate.value);
    }
  }

  public onCommentClientChange(): void {
    if (!this.data.commentClient.uiPrivatized) {
      this.data.commentClient.externalState = null;
      this.api.updateClientComment(this.refId, this.data.commentClient.value);
    }
  }

  public onCustomValuesChange(values: Array<CubiqTS.CustomValue>): void {
    this.data.customValues.value = values;
    this.data.customValues.externalState = null;
    this.api.updateCustomFields(this.refId, this.data.customValues.value);
  }

  public onCommentClientCheckboxChange(): void {
    setTimeout(() => {
      if (
        typeof this.data.commentClient.checkbox.value === "boolean" &&
        this.data.commentClient.checkbox.value
      ) {
        this.cd.detectChanges();
        if (
          this.data.commentClient.externalState === ICNInputControlState.INVALID &&
          this.data.commentClient.checkbox.value
        ) {
          this.data.commentClient.externalState = null;
        }
        this.icCommentClient.nativeElement.focus();
      }
    }, 0);
  }

  public onExecutionModeChange(): void {
    this.api.updateExecutionMode(this.refId, this.data.executionMode.value);
    setTimeout(() => {
      // invocation of updateTraderGroups() made asynchronous due to Synchronous event broadcasting which causes ExpressionChangedAfterItHasBeenCheckedError
      this.updateTraderGroups();
    }, 0);
  }

  public onHoldSTPChange(): void {
    this.api.updateHoldSTP(this.refId, this.data.holdSTP.value);
  }

  public onPrivateOrderChange(): void {
    if (!this.data.privateOrder.uiPrivatized) {
      this.api.updatePrivateOrder(this.refId, this.data.privateOrder.value);
    }
  }

  public onAllowPartialFillsStateChange(): void {
    this.evaluateSTPAgg();
    this.api.updateAllowPartialFills(this.refId, this.data.partialFill.value);
  }

  public onAllowStpAggStateChange(): void {
    this.api.updateAllowSTPAgg(this.refId, this.data.stpAgg.value);
  }

  /**********************************************************************/
  /* TRADER GROUP METHODS */

  /**
   * Loads and populates lists of trader groups
   */
  protected loadTraderGroups(): void {
    let lookup: TraderGroupLookupService = this.traderGroupService.getBase();
    let all: Array<CubiqTS.TradingGroupImpl> = lookup.getAll(); //.filter((traderGroup: CubiqTS.TradingGroupImpl) => traderGroup.groupId.toNumber() >= 0);
    if (all != null && all instanceof Array && all.length > 0) {
      all = all.filter(
        (traderGroup: CubiqTS.TradingGroupImpl) => traderGroup.groupId.toNumber() >= 0,
      );

      all.forEach((value: CubiqTS.TradingGroupImpl) => (value["id"] = value.groupId.toString()));
      all.sort((a: CubiqTS.TradingGroupImpl, b: CubiqTS.TradingGroupImpl) =>
        a.groupCode.toLowerCase().localeCompare(b.groupCode.toLowerCase()),
      );

      this.data.traderGroup.allTraderGroups = all;
      this.data.traderGroup.benchmarkTraderGroups = all.filter(
        (tradingGroup: CubiqTS.TradingGroupImpl) => tradingGroup.isBenchmarkFg,
      );
      this.data.traderGroup.limitTraderGroups = all.filter(
        (tradingGroup: CubiqTS.TradingGroupImpl) => !tradingGroup.isBenchmarkFg,
      );
      //
      this.data.traderGroup.manualTraderGroups = this.data.traderGroup.limitTraderGroups.filter(
        (value: CubiqTS.TradingGroupImpl) => !value.isAutoFilledFg,
      );
      this.data.traderGroup.manualVoiceOnlyTraderGroups =
        this.data.traderGroup.limitTraderGroups.filter(
          (value: CubiqTS.TradingGroupImpl) => !value.isAutoFilledFg && !value.isExternallyFilledFg,
        );
      //
      this.data.traderGroup.limitTraderGroups = this.data.traderGroup.limitTraderGroups.filter(
        (value: CubiqTS.TradingGroupImpl) => value.isAutoFilledFg,
      );
    } else {
      this.data.traderGroup.allTraderGroups = [];
      this.data.traderGroup.benchmarkTraderGroups = [];
      this.data.traderGroup.limitTraderGroups = [];
      this.data.traderGroup.manualTraderGroups = [];
      this.data.traderGroup.manualVoiceOnlyTraderGroups = [];
    }
  }

  /**
   * Searches the trader group suggestions for a infix matching of the given filter string
   * @param filter the filter should be checked to be an infix of the target trader group
   */
  public searchTraderGroup(filter: any): void {
    let traderGroups: Array<CubiqTS.TradingGroupImpl> = this.getTraderGroups();

    let query: string = filter.query.toLowerCase();
    if (query.length > 0) {
      this.data.traderGroup.traderGroups = traderGroups.filter((tradeGroup: any) =>
        tradeGroup.groupCode.toLowerCase().includes(query),
      );
    } else {
      this.data.traderGroup.traderGroups = traderGroups.slice(0);
    }
  }

  public onSelectTraderGroup(data: any): void {
    this.data.traderGroup.traderGroupVisited = true;
    this.validateTraderGroup();
    this.onTraderGroupChange();
  }

  public traderGroupFocus(): void {
    this.data.traderGroup.traderGroupVisited = true;
  }

  public validateTraderGroup(): void {
    let traderGroups: Array<CubiqTS.TradingGroupImpl> = this.getTraderGroups();

    if (this.data.traderGroup.value != null && typeof this.data.traderGroup.value === "string") {
      let code: string = (this.data.traderGroup.value as string).toLowerCase();
      let traderGroup: CubiqTS.TradingGroupImpl = traderGroups.find(
        (group: CubiqTS.TradingGroupImpl) => group.groupCode.toLowerCase() == code,
      );

      if (traderGroup != null) {
        this.data.traderGroup.value = traderGroup;
      } else if (code.trim().length == 0) {
        this.data.traderGroup.value = null;
      }
    }

    if (this.data.traderGroup.value === null || !this.data.traderGroup.traderGroupVisited) {
      this.data.traderGroup.state = ICNInputControlState.INACTIVE;
    } else {
      let valid: boolean = this.data.traderGroup.value instanceof CubiqTS.TradingGroupImpl;
      this.data.traderGroup.state = valid
        ? ICNInputControlState.VALID
        : ICNInputControlState.INVALID;
    }
  }

  private updateTraderGroups(): void {
    this.data.traderGroup.traderGroups = this.getTraderGroups();
    if (
      this.data.traderGroup.value != null &&
      this.data.traderGroup.traderGroups.indexOf(this.data.traderGroup.value) < 0
    ) {
      this.data.traderGroup.value = null; // Object.assign(new TradingGroupImpl(), { groupCode: '', id: null });
      this.data.traderGroup.state = ICNInputControlState.INACTIVE;
      this.onTraderGroupChange();
    }
  }

  private getTraderGroups(): Array<CubiqTS.TradingGroupImpl> {
    let groups: Array<CubiqTS.TradingGroupImpl> = this.data.traderGroup.allTraderGroups;

    if (this.isMKTOrder() || this.api.doesStrategyHaveMKTLeg(this.refId)) {
      groups = this.data.traderGroup.manualVoiceOnlyTraderGroups;
    } else {
      if (this.data.executionMode.value === CubiqTS.ExecutionType.AUTOMATIC) {
        groups = this.data.traderGroup.limitTraderGroups.concat(
          this.data.traderGroup.manualTraderGroups,
        );
      } else if (this.data.executionMode.value === CubiqTS.ExecutionType.MANUAL) {
        groups = this.data.traderGroup.manualTraderGroups;
      } else {
        logger.out.warn(
          `WARNING: oe${
            OENEntryType[this.entryType]
          }Entry.getTraderGroups(): Execution mode not specified! executionMode:`,
          this.data.executionMode.value,
        );
        groups = this.data.traderGroup.limitTraderGroups.concat(
          this.data.traderGroup.manualTraderGroups,
        );
      }
    }
    return groups;
  }
  /**********************************************************************/
  /* TRIGGER METHODS */

  // OLD CODE
  public reEvaluateTrigger($event: any): void {
    // update trigger logice if spot/fwd
    // NB : presume the pupose where was, If the trigger has not been set - to infer it from the valueDate
    if (this.data.trigger.value == null) {
      if (this.data.valueDate.isSpot) {
        this.data.trigger.value = this.data.trigger.spotTrigger;
      } else {
        //  if(!this.data.valueDate.isSpot && this.data.trigger.value == null)
        this.data.trigger.value = this.data.trigger.outrightTrigger;
      }
      this.validateTrigger();
      this.onTriggerChange();
    }
  }

  // NEW CODE
  /* 	public reEvaluateTrigger($event: any): void {
		if(!this.isMKTOrder()){
			this.data.trigger.locked = false;
		}

		if(this.data.trigger.value == null){
			if(this.data.valueDate.isSpot){
				this.data.trigger.value = this.data.trigger.spotTrigger;
			}else if(this.isMKTOrder()){
				this.data.trigger.value = this.data.trigger.spotTrigger;
				this.data.trigger.locked = true;
			} else{
				this.data.trigger.value = this.data.trigger.outrightTrigger;
			}
			this.validateTrigger();
			this.onTriggerChange();
		}
	} */

  /**
   * Searches the Triggers suggestions for a infix matching of the given filter string
   * @param filter the filter should be checked to be an infix of the target trader group
   */
  public searchTriggers(filter: any): void {
    let triggers: Array<ICAutocompleteGenericModel> = this.getTriggers();

    let query: string = filter.query.toLowerCase();
    if (query.length > 0) {
      this.data.trigger.dataset = triggers.filter((trigger: any) =>
        trigger.label.toLowerCase().includes(query),
      );
    } else {
      this.data.trigger.dataset = triggers.slice(0);
    }
  }

  public onSelectTrigger(data: any): void {
    this.validateTrigger();
    this.onTriggerChange();
    this.updateMarkupRates();
  }

  public triggerFocus(): void {
    this.data.trigger.state = ICNInputControlState.ACTIVE;
  }

  public validateTrigger(): void {
    let triggers: Array<ICAutocompleteGenericModel> = this.getTriggers();

    if (this.data.trigger.value != null) {
      let code: string =
        this.data.trigger.value instanceof ICAutocompleteGenericModel
          ? this.data.trigger.value.label.toLowerCase()
          : typeof this.data.trigger.value === "string"
            ? (this.data.trigger.value as string).toLowerCase()
            : null;
      let trigger = triggers.find(
        (group: ICAutocompleteGenericModel) => group.label.toLowerCase() == code,
      );

      if (trigger != null) {
        this.data.trigger.value = trigger;
      } else if (triggers.length > 0) {
        this.data.trigger.value = triggers[0];
      }
    }

    if (this.data.trigger.value === null) {
      this.data.trigger.state = ICNInputControlState.INACTIVE;
    } else {
      this.data.trigger.state = ICNInputControlState.VALID;
    }
  }

  protected getTriggers(): Array<ICAutocompleteGenericModel> {
    let triggers: Array<ICAutocompleteGenericModel> = [];
    if (this.data.currencyPair.model) {
      if (this.data.currencyPair.model.allowFwdSpotTriggerFg) {
        triggers.push(this.data.trigger.spotTrigger);
      }
      if (this.data.currencyPair.model.allowFwdFwdTriggerFg) {
        triggers.push(this.data.trigger.outrightTrigger);
      }
    }
    return triggers;
  }

  /**********************************************************************/
  /* CONSTRAINT PROPAGATION */

  private propagateClientChange(): void {
    /// execution mode
    this.data.executionMode.show = this.data.executionMode.showConfig;
    // comments
    if (
      (this.data.client.value != null &&
        this.data.previousValue.clientId !== this.data.client.value.clientId) ||
      (this.data.client.value == null && this.data.previousValue.client != null)
    ) {
      // _client is different
      if (this.data.client.value != null) {
        // client id has changed- set default
        let clientComment = this.api.getClientComment(this.refId);
        this.data.commentClient.value =
          clientComment && !this.data.commentClient.uiPrivatized
            ? clientComment
            : this.data.commentClient.uiPrivatized
              ? this.data.commentClient.privatizationLabel
              : "";
        this.data.commentPrivate.value =
          this.data.client.value.defaultPrivateComment != null &&
          !this.data.commentPrivate.uiPrivatized
            ? this.data.client.value.defaultPrivateComment
            : this.data.commentPrivate.uiPrivatized
              ? this.data.commentPrivate.privatizationLabel
              : "";
        this.onCommentPrivateChange();
      }
    }
    ///
    this.updateMarkupRates();

    ///
    this.data.previousValue.client = this.data.client.value;
    this.data.previousValue.clientId =
      this.data.previousValue.client != null ? this.data.previousValue.client.clientId : null;

    if (this.data.previousValue.client != null) {
      this.evaluateMarkupByBranch(this.data.previousValue.client.clientId);
    }
  }

  private clearSTPAgg() {
    this.data.stpAgg.value = ConstraintValue.None;
    this.evaluateSTPAgg();
  }

  /**
   * STP Aggregation depends on Order Type's
   *  - TR_REQUEST_ORDER_TYPE.STP_AGG_FG = 'Y'
   *  - TP part-fill visible and enabled
   */
  private evaluateSTPAgg() {
    const { show: oldShow, _value: oldValue } = this.data.stpAgg;
    const show = this.settings.isSTPAggAvailable(
      this.data.orderType?.value?.value,
      this.data.partialFill.show === true && ConstraintValue.isEnabled(this.data.partialFill.value),
    );
    let value: ConstraintValue = oldValue;
    let changed = false;

    if (show) {
      if (ConstraintValue.isPristine(this.data.stpAgg.value) && this.data.client.value != null) {
        value = this.data.client.value.stpAggregationDefaultFg
          ? ConstraintValue.FlagEnabled
          : ConstraintValue.FlagDisabled;
      } else if (ConstraintValue.isInvalid(this.data.stpAgg.value)) {
        value = ConstraintValue.asValid(this.data.stpAgg.value);
      }
    } else {
      value = ConstraintValue.asInvalid(this.data.stpAgg.value);
    }

    if (oldShow !== show) {
      this.data.stpAgg.show = show;
      changed = true;
    }

    if (oldValue !== value) {
      this.data.stpAgg.value = value;
      changed = true;
    }

    if (changed) {
      logger.out.info(
        `${this.constructor.name}.evaluateSTPAgg() show:${show} value: ${ConstraintValue.info(
          value,
        )}`,
      );

      this.cd.markForCheck();

      this.onAllowStpAggStateChange();
    }
  }

  private evaluateMarkupByBranch(clientStr: string): void {
    let client: CubiqTS.ClientImpl = this.clientLookupService.getItem(clientStr);
    let previousMarkupDisabledFg: boolean = this.data.markup.disabled;
    let markupEnabled: boolean = this.isMarkupEnabled(client);

    if (!previousMarkupDisabledFg && !markupEnabled) {
      this.propagateMarkupDefaultData();
      this.api.updateMarkup(this.refId, null);
    }
    this.data.markup.disabled = !markupEnabled;
  }

  private propagateAccountChange(): void {
    this.updateRetrieveMarkupEnabled();
  }

  public propagateClientDefaultCommentsChange(data: any): void {
    this.data.commentClient.value = this.data.commentClient.uiPrivatized
      ? this.data.commentClient.privatizationLabel
      : data.clientComment;
    this.data.commentPrivate.value = this.data.commentPrivate.uiPrivatized
      ? this.data.commentPrivate.privatizationLabel
      : data.privateComment;
    //this.onCommentClientChange();
    // this.onCommentPrivateChange();
  }

  /**********************************************************************/
  /* ORDER TYPE HELPERS/PROPAGATION */

  private propagateOrderTypeChange(postLoad: boolean = false): void {
    if (
      this.data.orderType != null &&
      this.data.orderType.value instanceof ICAutocompleteGenericModel
    ) {
      // If order type has changed to or from call, then the new FixedCcy control needs to be refreshed
      this.fixedCcyControl.forEach((c) => c.load(this.data.fixedCcy.value));

      // TP
      if (this.data.orderType.value.value === CubiqTS.RequestOrderType.TP) {
        this.data.partialFill.show = true;
      } else if (
        this.data.previousValue.orderType.lastValidId === CubiqTS.RequestOrderType.TP ||
        postLoad
      ) {
        this.data.partialFill.show = false;
      }
      // TSL
      if (this.isTSL()) {
        this.updateTrailingTrigger();
      } else if (this.isTSL(this.data.previousValue.orderType.lastValidId) || postLoad) {
        this.updateTrailingTrigger();
      }
      // CALL
      if (this.data.orderType.value.value === CubiqTS.RequestOrderType.CALL) {
        this.control.showRootCallCcy =
          this.getter.isRootNode(this.refId) && !this.getter.isRootNodeAlone(this.refId);
        if (this.control.showIntentAndAmount) {
          this.control.showIntentAndAmount = false;
          this.coordinator.cmdPropagateClientIntentChange(this.refId, null);
          this.icOrderType.forEach((c) => c.hidePanel());
          setTimeout(() => this.requestPriceInputControl.forEach((c) => c.focusInput()), 0);
        }
        this.data.markup.show = false;
      } else if (
        this.data.previousValue.orderType.lastValidId === CubiqTS.RequestOrderType.CALL ||
        postLoad
      ) {
        this.control.showRootCallCcy = false;
        this.control.showIntentAndAmount = true;
        this.coordinator.cmdPropagateClientIntentChange(this.refId, this.data.clientIntent.value);
        this.data.markup.show = true;
      }
      // MARKET
      if (this.data.orderType.value.value === CubiqTS.RequestOrderType.MARKET) {
        // partial fill
        this.data.partialFill.show = true;
        // request price
        this.control.applyRateUpdatesToRequest = false; // stop rate update application to requestRate
        this.requestPriceInputControl.forEach((c) => c.resetInputControl()); // reset
        this.data.requestPrice.lockState = OENLockedState.LOCKED; // lock
        // suspend checkbox
        {
          // reset
          this.data.suspend.value = null;
          this.data.suspend.from.externalState = null;
          this.data.suspend.to.externalState = null;
          this.suspendInputControl.forEach((c) => c.resetInputs());
          this.api.clearSuspendOnMKTStrategyLegs(this.refId);
        }
        this.data.suspend.lockState = OENLockedState.LOCKED; // lock
        // auto execute
        this.icExecutionMode.forEach((c) => c.reset()); // reset
        this.data.executionMode.lockState = OENLockedState.LOCKED; // locked
        // good until
        {
          let goodUntilValue = new ICGoodFromUntilModel();
          goodUntilValue.marketValue = "GTC"; // needed as we may be an aAlog, where null means DAY -which means if we reaload on error with null it will default back to DAY
          goodUntilValue.dayOrder = false;
          this.goodUntilInputControl.forEach((c) => c.loadGoodFromUntil(goodUntilValue));
          this.goodUntilInputControl.forEach((c) => c.onChange(null)); // because load dosen't trigger model update
        }
        this.data.goodUntil.lockState = OENLockedState.LOCKED; // locked

        // OMS-36144 - Allow market order children to be a different pair to the parent
        let orderSate: CubiqTS.OrderState = this.api.getSrvOrderState(this.refId);
        if (
          !this.api.isRoot(this.refId) &&
          this.operationMode != OENOperationMode.MODIFY_INFO &&
          this.operationMode != OENOperationMode.AMEND_MARKUP &&
          ![CubiqTS.OrderState.REJECTED, CubiqTS.OrderState.CANCELLED].includes(orderSate)
        ) {
          // ccy pair
          if (this.data.currencyPair.lockState === OENLockedState.LOCKED) {
            this.data.currencyPair.lockState = OENLockedState.UNLOCKED; // unlocked
            this.data.currencyPair.dataset = this.data.ccyPairDatasets.mktDataset;
          }
          // fixed ccy
          if (this.data.fixedCcy.lockState === OENLockedState.LOCKED) {
            this.data.fixedCcy.lockState = OENLockedState.UNLOCKED; // unlocked
          }
        }

        //OMS-35796
        //removed set mkt value date to spot as fwds are valid for MKT ordrs.
        // Update Trader Groups (filter manual only)
        this.updateTraderGroups();

        // Apply locking
        this.updateLocking();
      } else if (
        this.data.previousValue.orderType.lastValidId === CubiqTS.RequestOrderType.MARKET ||
        postLoad
      ) {
        // partial fill
        if (this.data.orderType.value.value !== CubiqTS.RequestOrderType.TP) {
          this.data.partialFill.show = false;
        }

        this.control.applyRateUpdatesToRequest = true; // restart rate update application to requestRate
        // Set request rate
        if (this.latestRateData && !postLoad) {
          this.onRateUpdate(this.latestRateData, true);
        }
        // auto execute
        this.icExecutionMode.forEach((c) => c.conditionalEnable()); // needed because the reset disables the control
        // LOCKING
        // reverse locking states from profile if available
        if (
          Array.isArray(this.control.lockingProfileData) &&
          this.control.lockingProfileData.length > 0
        ) {
          let requestRateLockItem = this.getLockProfileForInputElement(
            OENInputControl.REQUEST_PRICE,
          );
          if (requestRateLockItem instanceof OEInputLockStateItemModel) {
            this.assignLockStateToData(requestRateLockItem);
          }
          // suspend
          let suspendLockItem = this.getLockProfileForInputElement(OENInputControl.SUSPEND);
          if (suspendLockItem instanceof OEInputLockStateItemModel) {
            this.assignLockStateToData(suspendLockItem);
          }
          // execution mode
          let executionLockItem = this.getLockProfileForInputElement(
            OENInputControl.EXECUTION_MODE,
          );
          if (executionLockItem instanceof OEInputLockStateItemModel) {
            this.assignLockStateToData(executionLockItem);
          }
          // good until
          let goodUntilLockItem = this.getLockProfileForInputElement(OENInputControl.GOOD_UNTIL);
          if (goodUntilLockItem instanceof OEInputLockStateItemModel) {
            this.assignLockStateToData(goodUntilLockItem);
          }
          // value date
          if (this.entryType === OENEntryType.SPOT) {
            let valueDateLockItem = this.getLockProfileForInputElement(OENInputControl.VALUE_DATE);
            if (valueDateLockItem instanceof OEInputLockStateItemModel) {
              this.assignLockStateToData(valueDateLockItem);
            }
          }
        } else {
          // unlock
          this.data.requestPrice.lockState = OENLockedState.UNLOCKED;
          this.data.suspend.lockState = OENLockedState.UNLOCKED;
          this.data.executionMode.lockState = OENLockedState.UNLOCKED;
          this.data.goodUntil.lockState = OENLockedState.UNLOCKED;
          if (this.entryType === OENEntryType.SPOT) {
            this.data.valueDate.lockState = OENLockedState.UNLOCKED;
          }
        }

        // OMS-36144 - Allow market order children to be a different pair to the parent
        if (!this.api.isRoot(this.refId)) {
          this.data.currencyPair.lockState = OENLockedState.LOCKED; // locked
          this.data.fixedCcy.lockState = OENLockedState.LOCKED; // locked

          // update ccy-pair
          let rootCcyValues = this.api.getRootFixedCcy(this.refId);
          if (rootCcyValues instanceof ICFixedCcyModel) {
            this.icCcyPair.forEach((c) => c.load(rootCcyValues.ccyPair));
            this.onCcyPairBlur(rootCcyValues.ccyPair);
            setTimeout(() => {
              this.fixedCcyControl.forEach((c) => c.load(rootCcyValues, false));
              this.data.fixedCcy.ccyPair = rootCcyValues.ccyPair;
              this.data.fixedCcy.fixedCcy = rootCcyValues.ccy;
              this.cd.markForCheck();
            }, 50);
          } else {
            logger.out.error(
              `ERROR: oe${
                OENEntryType[this.entryType]
              }Entry.propagateOrderTypeChange(MKT): Invalid root fixed ccy model, could not update!`,
            );
          }
        }
        if (this.data.orderType.value.value !== CubiqTS.RequestOrderType.MARKET) {
          this.data.currencyPair.dataset = this.data.ccyPairDatasets.sptFwdDataset;
        }

        //this.loadValueDateDataset();
        // Update Trader Groups
        this.updateTraderGroups();
        // Apply locking
        this.updateLocking();
      }
    } else {
      this.oeLogger.outputDevLogToConsole(`DEV-MKT: Order Type == NULL`);
    }
    this.cd.markForCheck();
  }

  public getLockProfileForInputElement(_input: OENInputControl): OEInputLockStateItemModel {
    let itemLockState = this.control.lockingProfileData.filter((item) => {
      return item.input === _input;
    });
    if (itemLockState != null && itemLockState.length > 0) {
      return itemLockState[0];
    }
    return null;
  }

  private setValueDateToSPTForMKT(): void {
    if (this.entryType === OENEntryType.SPOT) {
      this.valueDateInputControl.forEach((c) => c.writeValue(null));
      this.data.valueDate.dataset = null;
      setTimeout(() => {
        this.loadValueDateDataset();
      }, 0);
    }
  }

  public updateRateApplicationToRequestRateGuard(): void {
    if (this.isMKTOrder()) {
      this.control.applyRateUpdatesToRequest = false;
    } else {
      this.control.applyRateUpdatesToRequest = true;
    }
  }

  public updateOrderTypeDatasetAvailability(): void {
    if (!this.control.isLoading) {
      this.excludeMKT = !this.isMKTAvailable();
      this.excludeTSL = !this.isTSLAvailableForCcyPair() || this.entryType == OENEntryType.NDF;

      this.orderTypeGetDataset();

      if ((this.excludeMKT && this.isMKTOrder()) || (this.excludeTSL && this.isTSLOrder())) {
        // load value - will trigger order type propagation
        this.icOrderType.forEach((c) => c.setDataValue(null, true, true, true));
      }
      if (!this.isMKTAvailable(false)) {
        this.updateRateApplicationToRequestRateGuard();
        if (this.api.isRoot(this.refId) && this.api.doesStrategyHaveMKTLeg(this.refId)) {
          this.api.clearOrderTypeOnMKTStrategyLegs(this.refId);
          //this.api.clearSuspendOnMKTStrategyLegs(this.refId);
        }
      }
    } else {
      this.excludeMKT = true;
      this.excludeTSL = !this.isTSLAvailableForCcyPair();
      this.orderTypeGetDataset();
    }
  }

  private isMKTAvailable(considerStrategyLegRelationships: boolean = true): boolean {
    if (this.configMKTEnabled) {
      // check system setting
      let clientBranch = this.api.getClientBranchOEModelProperty(this.refId);
      if (
        (this.data.client != null && this.data.client.value instanceof CubiqTS.ClientImpl) ||
        typeof clientBranch === "string"
      ) {
        // check if client is sey
        let branchCode =
          this.data.client != null && this.data.client.value instanceof CubiqTS.ClientImpl
            ? this.data.client.value.branchCd
            : clientBranch;
        let branch = this.branchLookupService.getItem(branchCode);
        if (branch instanceof CubiqTS.BranchImpl && branch.allowMarketOrdersFg) {
          // check if client branch is mkt allowed
          return this.isMKTAvailableForCcyPair(considerStrategyLegRelationships);
        } else {
          this.oeLogger.outputDevLogToConsole(
            `DEV-MKT: MKT Availability: NO (branch not MKT enabled)`,
          );
        }
      } else if (this.api.isModificationPrivatized(this.refId)) {
        // client is null, clientBranch is unknown due to privatization (OMS-36177)
        return this.isMKTAvailableForCcyPair(considerStrategyLegRelationships);
      } else {
        this.oeLogger.outputDevLogToConsole(
          `DEV-MKT: MKT Availability: NO (client not set or branch unknown)`,
        );
      }
    } else {
      this.oeLogger.outputDevLogToConsole(`DEV-MKT: MKT Availability: NO (system setting)`);
    }
    return false;
  }

  // separate function to avoid duplication
  private isMKTAvailableForCcyPair(considerStrategyLegRelationships: boolean = true): boolean {
    if (this.data.currencyPair != null && this.data.currencyPair.mktEnabled) {
      // check if ccyPair is mkt enabled
      if (considerStrategyLegRelationships) {
        let mktStrategyAllowed = this.api.isMKTAllowedForStrategyLeg(this.refId);
        this.oeLogger.outputDevLogToConsole(
          `DEV-MKT: MKT Availability: ${
            mktStrategyAllowed ? "YES" : "NO (strategy relationship not suitable)"
          }`,
        );
        return mktStrategyAllowed;
      } else {
        this.oeLogger.outputDevLogToConsole(
          `DEV-MKT: MKT Availability: YES (strategy implications not considered)`,
        );
        return true;
      }
    } else {
      this.oeLogger.outputDevLogToConsole(
        `DEV-MKT: MKT Availability: NO (ccy pair not MKT enabled)`,
      );
    }
    return false;
  }

  private isMKTOrder(): boolean {
    return (
      this.data.orderType != null &&
      this.data.orderType.value instanceof ICAutocompleteGenericModel &&
      this.data.orderType.value.value === CubiqTS.RequestOrderType.MARKET
    );
  }

  private isTSLOrder(): boolean {
    return (
      this.data.orderType != null &&
      this.data.orderType.value instanceof ICAutocompleteGenericModel &&
      this.isTSL(this.data.orderType.value.value)
    );
  }

  private isTSLAvailableForCcyPair(): boolean {
    return this.data.currencyPair != null && this.data.currencyPair.tslEnabled;
  }

  /**********************************************************************/
  /* RATE SUBSCRIPTION  */

  /**
   * Convenience method for setting the current currency pair of
   * the model. The method sets up the dependent elements in the model
   * as well.
   * @param productCode the product code (base + nonBase, or invert)
   * @returns true if the currency pair was found and setup, false otherwise
   */
  protected setCurrencyPair(productCode: string): boolean {
    if (
      !this.control.isLoading &&
      !this.data.markup.config.markupEntry &&
      this.operationMode !== OENOperationMode.MONITOR_EXECUTION
    ) {
      this.updateMarkup(null);
      this.api.updateMarkup(this.refId, null);
    }
    this.data.currencyPair.product = productCode;
    this.data.fixedCcy.ccyPair = productCode;
    this.oeLogger.outputDevLogToConsole(
      `DEV-CCY: Panel: Setter -> Triggered for ${productCode} | previous ${
        this.data.previousValue.product
      } | Outcome: ${this.data.previousValue.product !== productCode ? "DIFFERENT" : "SAME"}`,
    );
    if (this.data.previousValue.product !== productCode) {
      if (this.data.currencyPair.product != null) {
        let currencyPairLookup: CcyPairLookupService = this.currencyPairService.getBase();
        this.data.currencyPair.model = currencyPairLookup.getItem(productCode);
        this.data.currencyPair.inverted = false;
        this.data.currencyPair.base = this.data.currencyPair.product.substr(0, 3);
        this.data.currencyPair.nonBase = this.data.currencyPair.product.substr(3, 3);
        // Check if there is an invert available
        if (this.data.currencyPair.model == null) {
          this.data.currencyPair.model = currencyPairLookup.getCcyPair(
            productCode.substr(3, 3),
            productCode.substr(0, 3),
          );
          this.data.currencyPair.inverted = true;
          this.data.currencyPair.base = this.data.currencyPair.product.substr(3, 3);
          this.data.currencyPair.nonBase = this.data.currencyPair.product.substr(0, 3);
        }

        if (this.data.currencyPair.model) {
          this.data.currencyPair.spotEnabled = this.data.currencyPair.model.spotEnabledFg;
          this.data.currencyPair.fwdEnabled =
            this.data.currencyPair.model.allowFwdFwdTriggerFg ||
            this.data.currencyPair.model.allowFwdSpotTriggerFg;
          this.data.currencyPair.ndfEnabled =
            this.data.currencyPair.model.allowNdfFwdTriggerFg ||
            this.data.currencyPair.model.allowNdfSpotTriggerFg;
          this.data.currencyPair.mktEnabled = this.data.currencyPair.model.allowMarketOrdersFg;
          this.data.currencyPair.tslEnabled = this.data.currencyPair.model.allowTrailingOrdersFg;
        } else {
          this.resetCurrencyPairData();
        }
        /* RATE SUBSCRIPTION */
        let resubscribe = !(
          typeof this.data.previousValue.product === "string" &&
          this.data.previousValue.product === productCode.substr(3, 3) + productCode.substr(0, 3)
        );

        this.oeLogger.outputDevLogToConsole(
          `DEV-CCY: Panel: Setter -> ${this.data.currencyPair.product} => Base: ${this.data.currencyPair.base} | Non-base: ${this.data.currencyPair.nonBase} | ` +
            `Invert: ${this.data.currencyPair.inverted ? "YES" : "NO"} | Resubscribe: ${
              resubscribe ? "YES" : "NO"
            }`,
        );
        // unsubscribe
        if (resubscribe) {
          if (this.rateSubscription != null && this.data.previousValue.product != null) {
            this.unsubscribeRate(this.rootRefId, this.data.previousValue.product);
            // reset control
            this.requestPriceInputControl.forEach((c) => {
              if (c != null && c instanceof BfxPriceSpinnerComponent) {
                c.resetInputControl();
              }
            });
          }
          // subscribe
          //if(resubscribe)
          this.subscribeRate(this.rootRefId, productCode);
        } else if (this.latestRateData) {
          this.onRateUpdate(this.latestRateData, true);
        } else {
          logger.out.warn(`no rate data on invert`);
        }

        // update previous product
        this.data.previousValue.product = this.data.currencyPair.product;
        this.data.previousValue.inverted = this.data.currencyPair.inverted;
        //
        this.loadValueDateDataset();

        return true;
      } else {
        this.oeLogger.outputDevLogToConsole(`DEV-CCY: Panel: Setter -> NULL - RESET`);
        this.data.currencyPair.model = null;
        this.data.currencyPair.inverted = false;
        this.data.currencyPair.base = null;
        this.data.currencyPair.nonBase = null;
        this.data.currencyPair.fwdEnabled = false;
        this.data.currencyPair.ndfEnabled = false;
        this.data.currencyPair.mktEnabled = false;
        /* RATE SUBSCRIPTION */
        // cancel subscription
        this.unsubscribeRate(this.rootRefId, this.data.previousValue.product);
        // reset marketRate
        let displayModel = new OERateDisplayModel();
        displayModel.invalidate();
        this.data.marketRate = displayModel;
        this.icCcyPair.forEach((c) => c.setMarketRate(displayModel));
        // reset control
        this.oeLogger.outputDevLogToConsole(
          `INFO: oe${OENEntryType[this.entryType]}Panel: [${
            this.rootRefId
          }] Resetting requestRate value`,
        );
        this.requestPriceInputControl.forEach((c) => c.loadValue(null));
        // update previous product
        this.data.previousValue.product = null;
        this.data.previousValue.inverted = false;
        //
        this.loadValueDateDataset();

        return true;
      }
    } else {
      return false; // no actual change in the ccyPair
    }
  }

  private resetCurrencyPairData() {
    this.data.currencyPair.model = null;
    this.data.currencyPair.product = null;
    this.data.currencyPair.base = null;
    this.data.currencyPair.nonBase = null;
    this.data.currencyPair.inverted = false;
    this.data.currencyPair.spotEnabled = false;
    this.data.currencyPair.fwdEnabled = false;
    this.data.currencyPair.ndfEnabled = false;
    this.data.currencyPair.mktEnabled = false;
    this.data.currencyPair.tslEnabled = false;
  }

  protected unsubscribeRate(rootRefId: string, productCode: string) {
    this.latestRateData = null;

    if (this.rateSubscription) {
      this.rateSubscription.unsubscribe();
      this.rateSubscription = null;
    }

    if (typeof productCode === "string" && productCode.length == 6) {
      this.oeLogger.outputRateLogToConsole(
        `INFO: oe${OENEntryType[this.entryType]}Panel: [${
          this.rootRefId
        }] requesting Rate UNSUBSCRIBE for ${productCode} ${
          this.rootRefId != rootRefId ? " for (" + rootRefId + ")" : ""
        }`,
      );
      this.api.rateUnsubscribe(rootRefId, this.entryType, productCode);
    }
  }

  protected subscribeRate(rootRefId: string, productCode: string) {
    if (typeof productCode === "string" && productCode.length == 6) {
      this.oeLogger.outputRateLogToConsole(
        `INFO: oe${OENEntryType[this.entryType]}Panel: [${
          this.rootRefId
        }] requesting Rate SUBSCRIBE for ${productCode} ${
          this.rootRefId != rootRefId ? " for (" + rootRefId + ")" : ""
        }`,
      );
      let subscription = this.api.rateSubscribe(rootRefId, this.entryType, productCode);

      if (subscription != null && this.rateSubscription == null) {
        this.rateSubscription = subscription.subscribe(this.onRateUpdate.bind(this));
      } else {
        logger.out.error(
          `ERROR: oe${
            OENEntryType[this.entryType]
          }Entry.subscribeRate(): Rate subscription failed!`,
        );
      }
    }
  }

  protected onRateUpdate(rate: any, forceRateUpdate: boolean = false): void {
    this.oeLogger.outputRateLogToConsole(
      `INFO: oe${OENEntryType[this.entryType]}Panel: Rate Update -> New Rate`,
      false,
      rate,
    );

    if (
      rate instanceof OERateTransportModel &&
      rate.refIds instanceof Array &&
      rate.value instanceof OERateDataModel
    ) {
      if (rate.refIds.includes(this.rootRefId)) {
        this.latestRateData = rate;
        let rateData = rate.value;

        if (
          rateData.ccyPair === this.data.currencyPair.product ||
          rateData.invertedCcyPair === this.data.currencyPair.product
        ) {
          let displayModel =
            rateData.invertedCcyPair === this.data.currencyPair.product
              ? rateData.invertedDisplayModel
              : rateData.displayModel;
          let rateValue =
            rateData.invertedCcyPair === this.data.currencyPair.product
              ? rateData.invertedRateValue
              : rateData.rateValue;
          this.oeLogger.outputRateLogToConsole(
            `INFO: oe${OENEntryType[this.entryType]}Panel: [${
              this.rootRefId
            }] Received rate ${rateValue.toFixed(4)} for ${this.data.currencyPair.product} (${
              rateData.subscrKey
            })`,
          );

          if (
            displayModel instanceof OERateDisplayModel &&
            rateValue instanceof CubiqTS.BigNumber
          ) {
            // allocate display model
            this.data.marketRate = displayModel;
            this.icCcyPair.forEach((c) => c.setMarketRate(displayModel));

            if (this.control.applyRateUpdatesToRequest) {
              if (this.data.requestPrice.valueToBeLoaded != null && !forceRateUpdate) {
                // used in copy to skip overwrite
                this.data.requestPrice.valueToBeLoaded = null;
                this.oeLogger.outputRateLogToConsole(
                  `INFO: oe${OENEntryType[this.entryType]}Panel: [${
                    this.rootRefId
                  }] Skipped setting Request rate`,
                );
              } else {
                if (forceRateUpdate) {
                  this.data.requestPrice.valueToBeLoaded = null;
                }

                let controlValueIsNull: boolean = this.data.requestPrice.value == null;
                let controlValueIsZero: boolean =
                  this.data.requestPrice.value instanceof CubiqTS.BigNumber &&
                  this.data.requestPrice.value.isZero();

                if (controlValueIsNull || controlValueIsZero || forceRateUpdate) {
                  this.requestPriceInputControl.forEach((c) => c.loadValue(rateValue, true));
                  this.oeLogger.outputRateLogToConsole(
                    `INFO: oe${OENEntryType[this.entryType]}Panel: [${
                      this.rootRefId
                    }] set Request value of ${rateValue.toFixed(4)}`,
                  );
                  // Update tracking
                  setTimeout(() => {
                    this.requestPriceInputControl.forEach((c) => c.validateValue());
                    this.updateMarkupRates();
                    this.updateRetrieveMarkupEnabled();
                  }, 0);
                }
              }
            }
          } else {
            logger.out.error(
              `ERROR: oe${
                OENEntryType[this.entryType]
              }Entry.onRateUpdate(): Invalid Rate in Rate update`,
            );
          }
        } else if (this.data.currencyPair.product !== null) {
          logger.out.error(
            `ERROR: oe${
              OENEntryType[this.entryType]
            }Entry.onRateUpdate(): 'Invalid ccyPair in Rate update`,
          );
        }
      } else {
        this.oeLogger.outputRateLogToConsole(
          `INFO: oe${OENEntryType[this.entryType]}Entry.onRateUpdate(): '${
            rate != null && rate.value != null ? rate.value.ccyPair : "Unknown"
          } Rate for` +
            ` RefId ` +
            this.rootRefId +
            " not found in Rate ids [" +
            rate.refIds +
            "] -> Ignore",
        );
      }
    } else {
      logger.out.error(
        `ERROR: oe${
          OENEntryType[this.entryType]
        }Entry.onRateUpdate(): Invalid Rate Transport model`,
      );
    }
  }

  protected loadValueDateDataset(): void {
    if (
      this.data &&
      this.data.currencyPair &&
      this.data.currencyPair.product &&
      ((this.entryType === OENEntryType.SPOT &&
        (this.data.currencyPair.fwdEnabled || this.data.currencyPair.spotEnabled)) ||
        (this.entryType === OENEntryType.NDF && this.data.currencyPair.ndfEnabled))
    ) {
      let base: string = this.data.currencyPair.inverted
        ? this.data.currencyPair.product.substr(3, 3)
        : this.data.currencyPair.product.substr(0, 3);
      let nonBase: string = this.data.currencyPair.inverted
        ? this.data.currencyPair.product.substr(0, 3)
        : this.data.currencyPair.product.substr(3, 3);
      let product = this.entryType === OENEntryType.NDF ? CubiqTS.Product.NDF : CubiqTS.Product.FWD;

      this.calendarService
        .getCalendarWithHolidays(base, nonBase, product)
        .then((calendar: CubiqTS.CurrencyPairCalendarImpl) => {
          if (
            this.entryType === OENEntryType.SPOT &&
            calendar instanceof CubiqTS.CurrencyPairCalendarImpl &&
            Array.isArray(calendar.tenorToValueDateSet) &&
            calendar.tenorToValueDateSet.length > 1 &&
            this.data.currencyPair.spotEnabled &&
            !this.data.currencyPair.fwdEnabled
          ) {
            let reducedCalendar = JSON.parse(JSON.stringify(calendar));

            reducedCalendar.tenorToValueDateMap = new Map();
            reducedCalendar.tenorToValueDateSet = [];
            /* reducedCalendar.tenorToValueAndFixingDateMap = new Map();
					reducedCalendar.tenorToValueAndFixingDateSet = []; */

            let spotTenorToValueDateMapItem = (calendar as any).tenorToValueDateMap.get(
              CubiqTS.Tenor.SPOT,
            );
            if (spotTenorToValueDateMapItem != null) {
              reducedCalendar.tenorToValueDateMap.set(
                CubiqTS.Tenor.SPOT,
                spotTenorToValueDateMapItem,
              );
              reducedCalendar.tenorToValueDateSet.push(spotTenorToValueDateMapItem);
            } else {
              logger.out.error(`DEV-VD: spotTenorToValueDateMapItem not found`);
            }

            /* 	let spotTenorToFixingDateMapItem = (calendar as any).tenorToValueAndFixingDateMap.get(CubiqTS.Tenor.SPOT);
					if(spotTenorToFixingDateMapItem != null){
						reducedCalendar.tenorToValueAndFixingDateMap.set(CubiqTS.Tenor.SPOT, spotTenorToFixingDateMapItem);
						reducedCalendar.tenorToValueAndFixingDateSet.push(spotTenorToFixingDateMapItem)
					} */

            this.data.valueDate.dataset = reducedCalendar;
            this.goodUntilInputControl.forEach((c) =>
              c.refreshGoodUntilConstants(reducedCalendar, base, nonBase),
            );
          } else {
            this.data.valueDate.dataset = calendar;
            this.goodUntilInputControl.forEach((c) =>
              c.refreshGoodUntilConstants(calendar, base, nonBase),
            );
          }
        });
    } else {
      if (this.data.valueDate.dataset != null) {
        this.data.valueDate.dataset = null;
      } else {
        this.onValueDateChange(null);
      }
    }
  }

  /**********************************************************************/
  /* MARKUP METHODS */

  public onGetMarkupCriteria($event: any): void {
    this.retrieveMarkup();
  }

  protected updateRetrieveMarkupEnabled(): void {
    if (
      this.data.account.value != null &&
      this.data.client.value != null &&
      this.data.currencyPair.model != null &&
      this.data.fixedCcy.fixedCcy != null &&
      this.data.orderType.value != null &&
      (this.data.requestPrice.value != null ||
        this.data.orderType.value.value === CubiqTS.RequestOrderType.MARKET) &&
      this.data.orderAmount.value != null
    ) {
      this.data.markup.retrieveEnabled = true;
    } else {
      this.data.markup.retrieveEnabled = false;
    }
  }

  protected retrieveMarkup() {
    this.data.markup.criteria = null;
    let criteria: MarkupCriteria = this.forwardAdapter.createMarkupCriteria(
      this.getter.get(this.refId),
    );

    setTimeout(() => {
      this.data.markup.criteria = criteria;
      this.markupInputControl.forEach((c) => c.markupCriteriaUpdate(this.data.markup.criteria));
    }, 0);
  }

  protected updateMarkup(markup: ICMarkupModel) {
    if (markup == null) {
      // this.data.markup.value = null;
      this.markupInputControl.forEach((c) => c.writeValue(null));
    } else if (this.data.markup.value !== Number(markup.value)) {
      // this.data.markup.value = markup;
      this.markupInputControl.forEach((c) => c.load(markup));
    }
  }

  /*******************************/
  /* MARKUP TRACKING METHODS */
  public updateMarkupRates(): void {
    const isMarkupRatesValid = this.isMarkupRatesValid();
    const isClientValid =
      this.data.client.value != null && this.data.client.value instanceof CubiqTS.ClientImpl;
    let requestPrice: CubiqTS.BigNumber = BIG_NUMBER_ZERO;
    let markupDecs: CubiqTS.BigNumber = BIG_NUMBER_ZERO;
    let reverseEngineer: boolean = false;
    let isBuyBase: boolean;

    if (isClientValid) {
      reverseEngineer = this.isStop(this.data.orderType?.value?.value)
        ? this.data.client.value.reverseEngineerSLFg
        : this.data.orderType?.value?.value === CubiqTS.RequestOrderType.TP &&
          this.data.client.value.reverseEngineerTPFg;
    } else if (this.data.markup.value != null && this.data.markup.value instanceof ICMarkupModel) {
      // privatized orders
      reverseEngineer = this.data.markup.value.reverseEngineer === true;
    }

    markupDecs = isMarkupRatesValid ? this.markupPipsToDecs() : BIG_NUMBER_ZERO;
    requestPrice = isMarkupRatesValid
      ? new CubiqTS.BigNumber(this.data.requestPrice.value)
      : BIG_NUMBER_ZERO;
    isBuyBase =
      (this.data.clientIntent.value === CubiqTS.OrderIntent.BUY &&
        this.getBaseCcy() === this.data.fixedCcy.fixedCcy) ||
      (this.data.clientIntent.value === CubiqTS.OrderIntent.SELL &&
        this.getNonBaseCcy() === this.data.fixedCcy.fixedCcy);

    const markupData = {
      isMarkupRatesValid,
      isBuyBase,
      reverseEngineer,
      requestPrice,
      markupDecs,
    };
    this.updateTrackingRate(markupData);
    this.updateClientRate(markupData);
  }

  private updateClientRate({
    isMarkupRatesValid,
    isBuyBase,
    reverseEngineer,
    requestPrice,
    markupDecs,
  }: MarkupData) {
    if (isMarkupRatesValid) {
      const precision: number = Math.max(this.getEntryPrecision(), this.getMarkupPrecision());
      let clientRate;

      clientRate = reverseEngineer
        ? requestPrice
        : isBuyBase
          ? requestPrice.plus(markupDecs)
          : requestPrice.minus(markupDecs);

      if (clientRate.isLessThan(BIG_NUMBER_ZERO)) {
        clientRate = BIG_NUMBER_ZERO;
      }

      this.data.clientRate.value = clientRate;
      this.data.clientRate.textValue = clientRate.toFixed(precision);
    } else {
      this.data.clientRate.value = null;
      this.data.clientRate.textValue = "";
    }

    this.data.clientRate = { ...this.data.clientRate };
  }

  private updateTrackingRate({
    isMarkupRatesValid,
    isBuyBase,
    reverseEngineer,
    requestPrice,
    markupDecs,
  }: MarkupData): void {
    if (isMarkupRatesValid) {
      let precision: number = Math.max(this.getEntryPrecision(), this.getMarkupPrecision());
      let tracking: CubiqTS.BigNumber;

      tracking = reverseEngineer
        ? isBuyBase
          ? requestPrice.minus(markupDecs)
          : requestPrice.plus(markupDecs)
        : requestPrice;

      if (tracking.isLessThan(BIG_NUMBER_ZERO)) {
        tracking = BIG_NUMBER_ZERO;
      }

      this.data.trackingRate.value = tracking;
      this.data.trackingRate.textValue = tracking.toFixed(precision);
    } else {
      this.data.trackingRate.value = null;
      this.data.trackingRate.textValue = "";
    }
    this.data.trackingRate = { ...this.data.trackingRate };
  }

  private isMarkupRatesValid() {
    return (
      this.data.requestPrice.value != null &&
      this.data.requestPrice.value instanceof CubiqTS.BigNumber &&
      this.data.markup.value != null &&
      this.data.markup.value.typeValue != null &&
      this.data.orderType.value != null
    );
  }

  /** @returns markup in absolute value. need to decide how to apply */
  private markupPipsToDecs(): CubiqTS.BigNumber {
    if (
      this.data.markup.value.value != null &&
      this.data.markup.value?.value?.isZero() === false &&
      this.data.currencyPair.model != null &&
      this.data.fixedCcy.fixedCcy != null &&
      this.data.orderType.value != null
    ) {
      let markup: CubiqTS.BigNumber = BIG_NUMBER_ZERO;
      switch (this.data.markup.value.typeValue.value) {
        case CubiqTS.MarkUpType.Pips:
          markup = new CubiqTS.BigNumber(this.data.markup.value.value).times(
            new CubiqTS.BigNumber(10).pow(-this.getSpotPrecision()),
          );
          break;
        case CubiqTS.MarkUpType.Percentage:
          markup = new CubiqTS.BigNumber(this.data.requestPrice.value).times(
            new CubiqTS.BigNumber(this.data.markup.value.value).dividedBy(100),
          );
          break;
        case CubiqTS.MarkUpType.UsdPerMillion:
          markup = new CubiqTS.BigNumber(this.data.requestPrice.value)
            .times(this.data.markup.value.value)
            .dividedBy(1000000);
          break;
        default:
          break;
      }
      return markup;
    }
    return BIG_NUMBER_ZERO;
  }

  private getEntryPrecision(): number {
    if (this.data.currencyPair.model) {
      if (
        this.data.valueDate.isSpot === false &&
        CubiqTS.RequestTrackingType.OUTRIGHT_RATE === this.data.trigger.value?.value
      ) {
        if (this.data.currencyPair.inverted) {
          return this.data.currencyPair.model.fwdInvertDecimalsQty;
        } else {
          return this.data.currencyPair.model.fwdRateDecimalsQty;
        }
      } else {
        if (this.data.currencyPair.inverted) {
          return this.data.currencyPair.model.limitEntrySpotInvertDecimals;
        } else {
          return this.data.currencyPair.model.limitEntrySpotDecimals;
        }
      }
    }
    return 0;
  }

  private getMarkupPrecision(): number {
    let precision = 0;
    if (this.data.currencyPair.model) {
      if (this.data.currencyPair.inverted) {
        precision = this.data.currencyPair.model.markupSptInvDecimals;
      } else {
        precision = this.data.currencyPair.model.markupSptDecimals;
      }
    }
    return precision != null && typeof precision === "number" && precision >= 0 ? precision : 0;
  }

  private getSpotPrecision(): number {
    if (this.data.currencyPair.model) {
      if (this.data.currencyPair.inverted) {
        return this.data.currencyPair.model.spotInvertDecimalsQty;
      } else {
        return this.data.currencyPair.model.rateDecimalsQty;
      }
    }
    return 0;
  }

  /**********************************************************************/
  /* UTILITY  */
  private getBaseCcy(): string {
    if (this.data.currencyPair.model) {
      if (this.data.currencyPair.inverted) {
        return this.data.currencyPair.model.nonBase;
      }
      return this.data.currencyPair.model.base;
    }
    return null;
  }
  private getNonBaseCcy(): string {
    if (this.data.currencyPair.model) {
      if (this.data.currencyPair.inverted) {
        return this.data.currencyPair.model.base;
      }
      return this.data.currencyPair.model.nonBase;
    }
    return null;
  }

  protected checkMarkupDefault(type: CubiqTS.RequestOrderType): boolean {
    switch (type) {
      case CubiqTS.RequestOrderType.TP:
      case CubiqTS.RequestOrderType.SL_ATRATE:
      case CubiqTS.RequestOrderType.SL_ASK:
      case CubiqTS.RequestOrderType.SL_BID:
      case CubiqTS.RequestOrderType.TSL:
      case CubiqTS.RequestOrderType.TSL_ASK:
      case CubiqTS.RequestOrderType.TSL_BID:
      case CubiqTS.RequestOrderType.MARKET:
        return true;
      default:
        return false;
    }
  }

  private isStop(requestOrderType: CubiqTS.RequestOrderType): boolean {
    switch (requestOrderType) {
      case CubiqTS.RequestOrderType.SL_ASK:
      case CubiqTS.RequestOrderType.SL_ATRATE:
      case CubiqTS.RequestOrderType.SL_BID:
      case CubiqTS.RequestOrderType.TSL:
      case CubiqTS.RequestOrderType.TSL_ASK:
      case CubiqTS.RequestOrderType.TSL_BID:
        return true;
      default:
        return false;
    }
  }

  public isTSL(requestOrderType?: CubiqTS.RequestOrderType): boolean {
    if (!requestOrderType) requestOrderType = this.data.orderType?.value?.value;

    switch (requestOrderType) {
      case CubiqTS.RequestOrderType.TSL:
      case CubiqTS.RequestOrderType.TSL_ASK:
      case CubiqTS.RequestOrderType.TSL_BID:
        return true;
      default:
        return false;
    }
  }

  public updateOBOClient(oboClient: string): void {
    this.api.updateOBOClient(this.refId, oboClient);
  }

  public updateOBOAccount(oboAccount: string): void {
    this.api.updateOBOAccount(this.refId, oboAccount);
  }

  private isBranchMarkupEnabled(client: CubiqTS.ClientImpl): boolean {
    if (client != null) {
      // check if client is sey
      let branchCode = client != null ? client.branchCd : "";
      let branch = this.branchLookupService.getItem(branchCode);
      if (branch instanceof CubiqTS.BranchImpl && branch.applyMarkupFg) {
        // check if client branch is mkt allowed
        return true;
      }
    }
    return false;
  }

  protected isMarkupEnabled(client: CubiqTS.ClientImpl): boolean {
    let applyMarkup: boolean = this.isBranchMarkupEnabled(client);
    return applyMarkup;
  }
}
